/**
 * Returns a list of all participles used for the Spanish passive voice assessment.
 * For each participle, versions for all four possible suffixes (-o, -a, -os, -as) are included.
 * @returns {Array} The list with participles.
 */
export default [
	"ababillad",
	"abacorad",
	"abadernad",
	"abajad",
	"abalanzad",
	"abaldonad",
	"abalead",
	"abaluartad",
	"abanad",
	"abancalad",
	"abanderad",
	"abanderizad",
	"abandonad",
	"abanicad",
	"abañad",
	"abaratad",
	"abarbetad",
	"abarcad",
	"abarload",
	"abarquillad",
	"abarracad",
	"abarrad",
	"abarrotad",
	"abastad",
	"abastardad",
	"abastecid",
	"abastionad",
	"abatanad",
	"abatatad",
	"abatid",
	"abatojad",
	"abdicad",
	"abducid",
	"abejead",
	"abejonead",
	"abejorread",
	"abeldad",
	"abemolad",
	"aberrad",
	"abetunad",
	"abiert",
	"abigarrad",
	"abisagrad",
	"abismad",
	"abjurad",
	"ablacionad",
	"ablandad",
	"abluid",
	"abnegad",
	"abobad",
	"abocad",
	"abocetad",
	"abochornad",
	"abocinad",
	"abofad",
	"abofetead",
	"abogad",
	"abolid",
	"abollad",
	"abombad",
	"abominad",
	"abonad",
	"abordad",
	"aborrascad",
	"aborrecid",
	"aborregad",
	"abortad",
	"abotagad",
	"abotargad",
	"abotonad",
	"abovedad",
	"aboyad",
	"abracad",
	"abrasad",
	"abrazad",
	"abrevad",
	"abreviad",
	"abribonad",
	"abrigad",
	"abrillantad",
	"abrochad",
	"abrogad",
	"abroncad",
	"abrotoñad",
	"abrumad",
	"abscedid",
	"abscondid",
	"absolutizad",
	"absorbid",
	"abstenid",
	"abstergid",
	"abstraíd",
	"absuelt",
	"abuchead",
	"abultad",
	"abundad",
	"abuñolad",
	"aburguesad",
	"aburrid",
	"aburujad",
	"abusad",
	"acabad",
	"acaballad",
	"acachetead",
	"academizad",
	"acaecid",
	"acairelad",
	"acalambrad",
	"acalenturad",
	"acallad",
	"acalmad",
	"acalorad",
	"acamad",
	"acampad",
	"acampanad",
	"acanalad",
	"acantilad",
	"acantonad",
	"acañonead",
	"acaparad",
	"acaramelad",
	"acardenalad",
	"acariciad",
	"acarread",
	"acartonad",
	"acastillad",
	"acatad",
	"acatarrad",
	"acaudillad",
	"accedid",
	"accesad",
	"accidentad",
	"accionad",
	"acechad",
	"acedad",
	"aceitad",
	"acelerad",
	"acendrad",
	"acensad",
	"acensuad",
	"acentuad",
	"acepillad",
	"aceptad",
	"acerad",
	"acercad",
	"acerrojad",
	"acertad",
	"acervad",
	"acetad",
	"acetificad",
	"acezad",
	"achacad",
	"achaflanad",
	"achantad",
	"achaparrad",
	"achatad",
	"achatarrad",
	"achicad",
	"achicharrad",
	"achicopalad",
	"achinad",
	"achispad",
	"achocolatad",
	"acholad",
	"achorad",
	"achuchad",
	"acibarad",
	"acicalad",
	"acicatead",
	"acidificad",
	"acidulad",
	"aciemad",
	"acitronad",
	"aclamad",
	"aclarad",
	"aclimatad",
	"acobardad",
	"acobijad",
	"acodad",
	"acoderad",
	"acogid",
	"acogotad",
	"acojinad",
	"acojonad",
	"acolad",
	"acolchad",
	"acolchonad",
	"acolitad",
	"acollad",
	"acollarad",
	"acometid",
	"acomodad",
	"acompañad",
	"acompasad",
	"acomplejad",
	"acondicionad",
	"aconductad",
	"acongojad",
	"aconsejad",
	"acontecid",
	"acopiad",
	"acoplad",
	"acoquinad",
	"acorad",
	"acorazad",
	"acorchad",
	"acordad",
	"acordonad",
	"acorralad",
	"acorrid",
	"acortad",
	"acosad",
	"acostad",
	"acostumbrad",
	"acotad",
	"acotejad",
	"acotolad",
	"acovachad",
	"acrecentad",
	"acrecid",
	"acreditad",
	"acreíd",
	"acremad",
	"acrianzad",
	"acribillad",
	"acriminad",
	"acrisolad",
	"acristalad",
	"activad",
	"actuad",
	"actualizad",
	"acuantiad",
	"acuarelad",
	"acuartelad",
	"acuatizad",
	"acuchillad",
	"acuciad",
	"acuclillad",
	"acudid",
	"acuerpad",
	"acuitad",
	"aculad",
	"aculebrad",
	"aculturad",
	"acumulad",
	"acunad",
	"acuñad",
	"acurrucad",
	"acusad",
	"adamad",
	"adamascad",
	"adaptad",
	"adarvad",
	"adecentad",
	"adecuad",
	"adehesad",
	"adelantad",
	"adelgazad",
	"ademad",
	"adentrad",
	"aderezad",
	"adestrad",
	"adeudad",
	"adherid",
	"adiad",
	"adicionad",
	"adiestrad",
	"adietad",
	"adinerad",
	"adivinad",
	"adjetivad",
	"adjudicad",
	"adjuntad",
	"administrad",
	"admirad",
	"admitid",
	"adobad",
	"adocenad",
	"adoctrinad",
	"adolecid",
	"adoptad",
	"adoquinad",
	"adorad",
	"adormecid",
	"adormid",
	"adormilad",
	"adornad",
	"adosad",
	"adquirid",
	"adscript",
	"adscrit",
	"aducid",
	"adueñad",
	"adujad",
	"adulad",
	"adulterad",
	"adurid",
	"advenid",
	"adverad",
	"adversad",
	"advertid",
	"advocad",
	"adyacid",
	"aerad",
	"aerografiad",
	"aerotransportad",
	"afamad",
	"afanad",
	"afantasmad",
	"afead",
	"afectad",
	"afeitad",
	"afelpad",
	"afeminad",
	"aferrad",
	"afianzad",
	"aficionad",
	"afiebrad",
	"afilad",
	"afiliad",
	"afiligranad",
	"afinad",
	"afincad",
	"afirmad",
	"aflamencad",
	"afligid",
	"aflojad",
	"aflorad",
	"afluid",
	"aforad",
	"aforrad",
	"afortunad",
	"afrancesad",
	"afrentad",
	"africanizad",
	"afrontad",
	"agachad",
	"agarrad",
	"agarrotad",
	"agasajad",
	"agavillad",
	"agazapad",
	"agenciad",
	"agendad",
	"agermanad",
	"aggiornad",
	"agigantad",
	"agilipollad",
	"agilizad",
	"agitad",
	"agitanad",
	"aglomerad",
	"aglutinad",
	"agobiad",
	"agolpad",
	"agonizad",
	"agorad",
	"agostad",
	"agotad",
	"agraciad",
	"agradad",
	"agradecid",
	"agrandad",
	"agravad",
	"agraviad",
	"agredid",
	"agregad",
	"agremiad",
	"agriad",
	"agrietad",
	"agringad",
	"agripad",
	"agrisad",
	"agrumad",
	"agrupad",
	"aguad",
	"aguaitad",
	"aguantad",
	"aguapad",
	"aguardad",
	"agudizad",
	"agüevad",
	"aguijad",
	"aguijonead",
	"aguisad",
	"agüitad",
	"agujerad",
	"agujeread",
	"agusanad",
	"aguzad",
	"ahajad",
	"ahechad",
	"aherrojad",
	"aherrumbrad",
	"ahijad",
	"ahilad",
	"ahincad",
	"ahinojad",
	"ahitad",
	"ahogad",
	"ahondad",
	"ahorcad",
	"ahorcajad",
	"ahormad",
	"ahorquillad",
	"ahorrad",
	"ahuecad",
	"ahumad",
	"ahusad",
	"ahuyentad",
	"airad",
	"airead",
	"aislad",
	"ajad",
	"ajamonad",
	"ajardinad",
	"ajetread",
	"ajuarad",
	"ajuntad",
	"ajustad",
	"ajusticiad",
	"alabad",
	"alabead",
	"alaciad",
	"alambicad",
	"alambrad",
	"alampad",
	"alancead",
	"alardead",
	"alargad",
	"alarmad",
	"albead",
	"albergad",
	"alboread",
	"alborotad",
	"alborozad",
	"alburead",
	"alcahuetead",
	"alcalinizad",
	"alcanforad",
	"alcantarillad",
	"alcanzad",
	"alcoholad",
	"alcoholizad",
	"alcorzad",
	"alead",
	"aleatorizad",
	"alebrestad",
	"aleccionad",
	"alechugad",
	"alegad",
	"alegorizad",
	"alegrad",
	"alejad",
	"alelad",
	"alentad",
	"alertad",
	"aletargad",
	"aletead",
	"alevantad",
	"alfabetizad",
	"alfalfad",
	"alfombrad",
	"algodonad",
	"alhajad",
	"aliad",
	"alicatad",
	"alienad",
	"aligerad",
	"alijad",
	"alijarad",
	"alimentad",
	"alindad",
	"alinead",
	"aliñad",
	"alisad",
	"alistad",
	"aliviad",
	"alivianad",
	"allanad",
	"allegad",
	"almacenad",
	"almagrad",
	"almenad",
	"almendrad",
	"almibarad",
	"almidonad",
	"almizclad",
	"almohadillad",
	"almohazad",
	"almorzad",
	"alocad",
	"alojad",
	"alongad",
	"alquilad",
	"alquitarad",
	"alquitranad",
	"altead",
	"alterad",
	"altercad",
	"alternad",
	"aluciflipad",
	"alucinad",
	"aludid",
	"alumbrad",
	"alunizad",
	"aluzad",
	"alzad",
	"amacollad",
	"amad",
	"amadrinad",
	"amaestrad",
	"amagad",
	"amainad",
	"amaitinad",
	"amalgamad",
	"amamantad",
	"amancebad",
	"amancillad",
	"amanecid",
	"amanerad",
	"amansad",
	"amanzanad",
	"amañad",
	"amarad",
	"amargad",
	"amariconad",
	"amarillead",
	"amarillecid",
	"amarizad",
	"amarrad",
	"amartelad",
	"amartillad",
	"amartizad",
	"amasad",
	"amasijad",
	"ambicionad",
	"ambientad",
	"amblad",
	"ambulad",
	"amedrentad",
	"amelcochad",
	"amenazad",
	"amenguad",
	"amenizad",
	"americanizad",
	"ameritad",
	"amerizad",
	"ametrallad",
	"amigad",
	"amilanad",
	"aminorad",
	"amistad",
	"amnistiad",
	"amoblad",
	"amodorrad",
	"amohinad",
	"amojamad",
	"amojonad",
	"amolad",
	"amoldad",
	"amonad",
	"amonedad",
	"amonestad",
	"amontonad",
	"amoratad",
	"amordazad",
	"amorrad",
	"amortajad",
	"amortiguad",
	"amortizad",
	"amoscad",
	"amostazad",
	"amotinad",
	"amovid",
	"amparad",
	"ampliad",
	"amplificad",
	"ampollad",
	"amputad",
	"amueblad",
	"amurad",
	"amurallad",
	"amurrad",
	"amusgad",
	"anadead",
	"analizad",
	"anarquizad",
	"anastomosad",
	"anatematizad",
	"anchad",
	"anclad",
	"ancorad",
	"andad",
	"andaluzad",
	"andamiad",
	"aneblad",
	"anegad",
	"anestesiad",
	"anexad",
	"anexionad",
	"anglicanizad",
	"anglificad",
	"angostad",
	"angulad",
	"angustiad",
	"anhelad",
	"anidad",
	"anihilad",
	"anillad",
	"animad",
	"animalizad",
	"aniñad",
	"aniquilad",
	"anisad",
	"anochecid",
	"anodizad",
	"anonadad",
	"anonimizad",
	"anotad",
	"anoticiad",
	"anquilosad",
	"ansiad",
	"antagonizad",
	"antecedid",
	"antecogid",
	"antedatad",
	"antedich",
	"antepagad",
	"antepasad",
	"antepuest",
	"antevenid",
	"antevist",
	"anticipad",
	"anticuad",
	"antiguad",
	"antojad",
	"antologad",
	"antologizad",
	"antropizad",
	"antropomorfizad",
	"anualizad",
	"anublad",
	"anudad",
	"anulad",
	"anunciad",
	"añadid",
	"añejad",
	"añorad",
	"añublad",
	"añudad",
	"aojad",
	"aovad",
	"apabullad",
	"apacentad",
	"apachad",
	"apachurrad",
	"apaciguad",
	"apadrinad",
	"apagad",
	"apalabrad",
	"apalancad",
	"apalead",
	"apalizad",
	"apanad",
	"apandad",
	"apaniguad",
	"apantallad",
	"apañad",
	"apapachad",
	"aparad",
	"aparatad",
	"aparcad",
	"aparead",
	"aparecid",
	"aparejad",
	"aparentad",
	"apartad",
	"apasionad",
	"apatrullad",
	"apayasad",
	"apead",
	"apechugad",
	"apedazad",
	"apedrad",
	"apedread",
	"apegad",
	"apelad",
	"apellidad",
	"apelmazad",
	"apelotad",
	"apelotonad",
	"apenad",
	"apencad",
	"apercibid",
	"aperrad",
	"aperread",
	"apersonad",
	"apertrechad",
	"aperturad",
	"apesadumbrad",
	"apesarad",
	"apestad",
	"apetecid",
	"apiadad",
	"apilad",
	"apiñad",
	"apiolad",
	"apipad",
	"apisonad",
	"aplacad",
	"aplanad",
	"aplanchad",
	"aplastad",
	"aplatanad",
	"aplaudid",
	"aplazad",
	"aplegad",
	"aplicad",
	"aplomad",
	"apocad",
	"apocopad",
	"apodad",
	"apoderad",
	"apolillad",
	"apoltronad",
	"apoquinad",
	"aporread",
	"aportad",
	"aposentad",
	"apostad",
	"apostatad",
	"apostillad",
	"apostrofad",
	"apoyad",
	"apreciad",
	"aprehendid",
	"apremiad",
	"aprendid",
	"apresad",
	"aprestad",
	"apresurad",
	"apretad",
	"apretujad",
	"apriscad",
	"aprisionad",
	"aprobad",
	"aproblemad",
	"aprontad",
	"apropiad",
	"apropriad",
	"aprovechad",
	"aprovisionad",
	"aproximad",
	"aptad",
	"apuest",
	"apuntad",
	"apuntalad",
	"apuntillad",
	"apuñalad",
	"apurad",
	"aquejad",
	"aquerenciad",
	"aquietad",
	"aquilatad",
	"arabizad",
	"arad",
	"arañad",
	"araucanizad",
	"arbitrad",
	"arbolad",
	"arborizad",
	"archivad",
	"arcillad",
	"ardid",
	"arenad",
	"arengad",
	"argentad",
	"argüendead",
	"argüid",
	"argumentad",
	"arietad",
	"armad",
	"armonizad",
	"aromad",
	"aromatizad",
	"arpegiad",
	"arponad",
	"arponead",
	"arquead",
	"arrabalizad",
	"arracimad",
	"arraigad",
	"arramblad",
	"arramplad",
	"arrancad",
	"arranchad",
	"arrasad",
	"arrastrad",
	"arread",
	"arrebañad",
	"arrebatad",
	"arrebolad",
	"arrebujad",
	"arreciad",
	"arrecid",
	"arredrad",
	"arregazad",
	"arreglad",
	"arrejuntad",
	"arrellanad",
	"arremangad",
	"arrematad",
	"arremedad",
	"arremetid",
	"arremolinad",
	"arrempujad",
	"arrendad",
	"arrepentid",
	"arrestad",
	"arriad",
	"arribad",
	"arriesgad",
	"arrimad",
	"arrinconad",
	"arriostrad",
	"arriscad",
	"arrobad",
	"arrodillad",
	"arrogad",
	"arrojad",
	"arrollad",
	"arromad",
	"arropad",
	"arrostrad",
	"arroyad",
	"arruad",
	"arrugad",
	"arruinad",
	"arrullad",
	"arrumad",
	"arrumbad",
	"articulad",
	"artillad",
	"aruñad",
	"asad",
	"asaetead",
	"asalariad",
	"asaltad",
	"ascendid",
	"asead",
	"asechad",
	"asediad",
	"asegurad",
	"asemejad",
	"asenderead",
	"asentad",
	"asentid",
	"aserrad",
	"aserruchad",
	"asesinad",
	"asesorad",
	"asestad",
	"aseverad",
	"asfaltad",
	"asfixiad",
	"asid",
	"asignad",
	"asilad",
	"asilvestrad",
	"asimilad",
	"asistid",
	"asociad",
	"asolad",
	"asolead",
	"asomad",
	"asombrad",
	"asonantad",
	"asordad",
	"aspad",
	"asperjad",
	"aspirad",
	"asquead",
	"astillad",
	"astreñid",
	"astringid",
	"astriñid",
	"asturianizad",
	"asumid",
	"asustad",
	"atacad",
	"atad",
	"atajad",
	"atalayad",
	"atañid",
	"atarantad",
	"atarazad",
	"ataread",
	"atarragad",
	"atarugad",
	"atascad",
	"ataviad",
	"atemorizad",
	"atemperad",
	"atenacead",
	"atenazad",
	"atendid",
	"atenid",
	"atentad",
	"atenuad",
	"aterid",
	"aterrad",
	"aterrazad",
	"aterrizad",
	"aterrorizad",
	"atesad",
	"atesorad",
	"atestad",
	"atestiguad",
	"atezad",
	"atiborrad",
	"atiesad",
	"atildad",
	"atinad",
	"atirantad",
	"atisbad",
	"atizad",
	"atollad",
	"atolondrad",
	"atomizad",
	"atontad",
	"atorad",
	"atorgad",
	"atormentad",
	"atornillad",
	"atorrad",
	"atosigad",
	"atracad",
	"atragantad",
	"atraíd",
	"atraillad",
	"atrancad",
	"atrapad",
	"atrasad",
	"atravesad",
	"atreguad",
	"atrevid",
	"atribuid",
	"atribulad",
	"atrincherad",
	"atrofiad",
	"atrojad",
	"atronad",
	"atropad",
	"atropellad",
	"atufad",
	"aturad",
	"aturdid",
	"aturrullad",
	"aturullad",
	"atusad",
	"audicionad",
	"auditad",
	"augmentad",
	"augurad",
	"aullad",
	"aumentad",
	"aunad",
	"aupad",
	"aureolad",
	"auscultad",
	"ausentad",
	"auspiciad",
	"autenticad",
	"autentificad",
	"autoabastecid",
	"autoadiestrad",
	"autoadministrad",
	"autoafirmad",
	"autoaislad",
	"autoalimentad",
	"autoanalizad",
	"autoaplicad",
	"autoasignad",
	"autobautizad",
	"autobloquead",
	"autobombead",
	"autocalificad",
	"autocensurad",
	"autocompletad",
	"autoconducid",
	"autoconsiderad",
	"autoconsumid",
	"autoconvocad",
	"autocoronad",
	"autocorregid",
	"autocremad",
	"autodeclarad",
	"autodefendid",
	"autodefinid",
	"autodelatad",
	"autodenominad",
	"autodescartad",
	"autodescript",
	"autodescrit",
	"autodestruid",
	"autodeterminad",
	"autodirigid",
	"autodisuelt",
	"autoeditad",
	"autoeliminad",
	"autoengañad",
	"autoensamblad",
	"autoevacuad",
	"autoevaluad",
	"autoexcluid",
	"autoexigid",
	"autoexiliad",
	"autoexplotad",
	"autofinanciad",
	"autogestionad",
	"autogobernad",
	"autografiad",
	"autoidentificad",
	"autoimpuest",
	"autoinculpad",
	"autoinmolad",
	"autolesionad",
	"autolimitad",
	"automarginad",
	"automatizad",
	"automedicad",
	"automejorad",
	"automutilad",
	"autonombrad",
	"autonomizad",
	"autopagad",
	"autoparodiad",
	"autopreparad",
	"autopresentad",
	"autoproclamad",
	"autoproducid",
	"autoprogramad",
	"autopromocionad",
	"autopropagad",
	"autoprotegid",
	"autopublicad",
	"autoreconocid",
	"autoregulad",
	"autorizad",
	"autorrealizad",
	"autorreconocid",
	"autorregulad",
	"autorreportad",
	"autorreproducid",
	"autorretratad",
	"autosabotead",
	"autotitulad",
	"auxiliad",
	"avalad",
	"avalentad",
	"avalorad",
	"avaluad",
	"avanzad",
	"avasallad",
	"avecinad",
	"avecindad",
	"avellanad",
	"avenid",
	"aventad",
	"aventajad",
	"aventurad",
	"averad",
	"avergonzad",
	"averiad",
	"averiguad",
	"avezad",
	"aviad",
	"avinagrad",
	"avisad",
	"avispad",
	"avistad",
	"avituallad",
	"avivad",
	"avizorad",
	"avocad",
	"avulsionad",
	"ayudad",
	"ayunad",
	"ayuntad",
	"ayustad",
	"azadonad",
	"azafranad",
	"azarad",
	"azogad",
	"azolvad",
	"azorad",
	"azotad",
	"azucarad",
	"azufrad",
	"azulad",
	"azulead",
	"azulejad",
	"azuzad",
	"babead",
	"babosead",
	"bachaquead",
	"bachead",
	"badajead",
	"bailad",
	"bailotead",
	"bajad",
	"bajonead",
	"balacead",
	"balad",
	"balancead",
	"balbucead",
	"balbucid",
	"balcanizad",
	"balconead",
	"baldad",
	"baldead",
	"balead",
	"balizad",
	"balotad",
	"balsead",
	"bambolead",
	"banalizad",
	"bancad",
	"bancarizad",
	"bandead",
	"banderillead",
	"banead",
	"banquetead",
	"bañad",
	"baptizad",
	"baquetead",
	"baquiad",
	"barajad",
	"barajead",
	"baratad",
	"barbad",
	"barbarizad",
	"barbechad",
	"barbotad",
	"barbotead",
	"baremad",
	"barequead",
	"barloventead",
	"barnizad",
	"barrad",
	"barread",
	"barrenad",
	"barretead",
	"barrid",
	"barritad",
	"barruntad",
	"basad",
	"basculad",
	"bastad",
	"bastardead",
	"bastid",
	"bastonead",
	"basuread",
	"batallad",
	"batead",
	"batid",
	"bautizad",
	"baylad",
	"beatificad",
	"bebid",
	"becad",
	"becerread",
	"bendecid",
	"bendit",
	"beneficiad",
	"berread",
	"besad",
	"besucad",
	"besuquead",
	"bichead",
	"bifurcad",
	"bilateralizad",
	"binad",
	"bioacumulad",
	"bioconcentrad",
	"biodegradad",
	"biodiversificad",
	"biofortificad",
	"biografiad",
	"biosintetizad",
	"birlad",
	"bisad",
	"bisbisad",
	"bisecad",
	"biselad",
	"bizcad",
	"bizmad",
	"bizquead",
	"blandead",
	"blandid",
	"blanquead",
	"blanquecid",
	"blasfemad",
	"blasonad",
	"blindad",
	"blocad",
	"blofead",
	"bloguead",
	"bloquead",
	"bobead",
	"bobinad",
	"bochad",
	"bocinad",
	"bofetead",
	"bogad",
	"boicotead",
	"bojad",
	"bojead",
	"bolead",
	"boletead",
	"boletinad",
	"bolivianizad",
	"bolsead",
	"bombardead",
	"bombead",
	"bonificad",
	"bootead",
	"boquead",
	"borbollad",
	"borbotad",
	"borbotead",
	"bordad",
	"bordead",
	"bordonead",
	"borrad",
	"borrajead",
	"borronead",
	"bosad",
	"bosquejad",
	"bostezad",
	"botad",
	"botanizad",
	"botead",
	"botonad",
	"botonead",
	"boxead",
	"boyad",
	"bracead",
	"bramad",
	"brasead",
	"bread",
	"bregad",
	"brezad",
	"bridad",
	"brillad",
	"brincad",
	"brindad",
	"britanizad",
	"brizad",
	"bromead",
	"broncead",
	"brotad",
	"brujulead",
	"bruñid",
	"brutalizad",
	"bucead",
	"buelt",
	"bufad",
	"bufonead",
	"buitread",
	"bulead",
	"bullid",
	"burbujead",
	"burilad",
	"burlad",
	"burocratizad",
	"buscad",
	"buzad",
	"buzonead",
	"bypasead",
	"cabalgad",
	"cabecead",
	"cabestrad",
	"cabestread",
	"cabid",
	"cabildead",
	"cabizbajad",
	"cablead",
	"cablegrafiad",
	"cabrahigad",
	"cabread",
	"cabrestead",
	"cabrillead",
	"cabriolad",
	"cabriolead",
	"çabullid",
	"caçad",
	"cacaread",
	"cachad",
	"cachead",
	"cachetead",
	"cachimbead",
	"cachiporread",
	"cachondead",
	"cachuread",
	"caducad",
	"cafichad",
	"cafichead",
	"cagad",
	"caíd",
	"cairelad",
	"cajonead",
	"calabriad",
	"calad",
	"calafatead",
	"calcad",
	"calcetad",
	"calcificad",
	"calcinad",
	"calculad",
	"caldead",
	"calefaccionad",
	"calefactad",
	"calendarizad",
	"calentad",
	"calibrad",
	"calificad",
	"caligrafiad",
	"callad",
	"callejead",
	"calmad",
	"calumniad",
	"calzad",
	"cambalachad",
	"cambalachead",
	"cambiad",
	"camelad",
	"caminad",
	"camorread",
	"camotead",
	"campad",
	"campanead",
	"campead",
	"campeonad",
	"camuflad",
	"camuflajead",
	"canalizad",
	"cancanead",
	"cancelad",
	"cancerad",
	"candad",
	"candidatad",
	"candidatead",
	"candidatizad",
	"canead",
	"canibalizad",
	"canjead",
	"canonizad",
	"cansad",
	"cantad",
	"cantead",
	"cantinflead",
	"canturread",
	"canturriad",
	"cañonead",
	"caotizad",
	"capacitad",
	"capad",
	"capead",
	"capitalizad",
	"capitanead",
	"capitulad",
	"capolad",
	"capotad",
	"capotead",
	"capsulad",
	"captad",
	"capturad",
	"capuzad",
	"caracolead",
	"caracterizad",
	"caramelizad",
	"caratulad",
	"carbonad",
	"carbonead",
	"carbonizad",
	"carburad",
	"carburizad",
	"carcajead",
	"carcomid",
	"cardad",
	"caread",
	"carecid",
	"carenad",
	"cargad",
	"cariad",
	"caricaturad",
	"caricaturizad",
	"cariciad",
	"carminad",
	"carnavalead",
	"carnavalizad",
	"carnead",
	"carnetizad",
	"carpid",
	"carraspead",
	"carretead",
	"carrilead",
	"carrozad",
	"cartead",
	"cartelizad",
	"carteread",
	"cartografiad",
	"casad",
	"cascabelead",
	"cascad",
	"castañead",
	"castañetead",
	"castellanizad",
	"castigad",
	"castrad",
	"catabolizad",
	"catad",
	"catalanizad",
	"catalizad",
	"catalogad",
	"catapultad",
	"catead",
	"categorizad",
	"catequizad",
	"cativad",
	"catolizad",
	"caucionad",
	"causad",
	"cautelad",
	"cauterizad",
	"cautivad",
	"cavad",
	"cavilad",
	"cazad",
	"cebad",
	"cecead",
	"cedid",
	"cedulad",
	"cegad",
	"cejad",
	"celad",
	"celebrad",
	"cementad",
	"cenad",
	"cencerread",
	"cendrad",
	"censad",
	"censurad",
	"centellad",
	"centellead",
	"centrad",
	"centralizad",
	"centrifugad",
	"centuplicad",
	"ceñid",
	"cepillad",
	"cercad",
	"cercenad",
	"cerchad",
	"cerciorad",
	"cerdead",
	"cernid",
	"cerrad",
	"certificad",
	"cesad",
	"cesantead",
	"cespitad",
	"chachad",
	"chacharead",
	"chacotead",
	"chafad",
	"chafardead",
	"chalad",
	"chamarilead",
	"chambead",
	"champurrad",
	"chamullad",
	"chamuscad",
	"chamuyad",
	"chancead",
	"chancletead",
	"chanelad",
	"changuead",
	"chantajead",
	"chantead",
	"chapad",
	"chapalead",
	"chapead",
	"chapotead",
	"chapucead",
	"chapurrad",
	"chapurread",
	"chapuzad",
	"chaquetead",
	"charlad",
	"charlatanead",
	"charlotead",
	"charolad",
	"charquead",
	"chascad",
	"chasquead",
	"chatead",
	"chavetead",
	"checad",
	"chequead",
	"chicanead",
	"chichad",
	"chicharrad",
	"chicotead",
	"chiflad",
	"chillad",
	"chinchad",
	"chinead",
	"chingad",
	"chinguead",
	"chipead",
	"chiquead",
	"chirlad",
	"chirriad",
	"chismead",
	"chismorread",
	"chismosead",
	"chispad",
	"chispead",
	"chisporrotead",
	"chistad",
	"chivad",
	"chivatead",
	"chocad",
	"chochead",
	"chollad",
	"chopead",
	"choread",
	"chorizad",
	"chorread",
	"chotad",
	"chotead",
	"chufad",
	"chulead",
	"chupad",
	"chupetead",
	"churrascad",
	"churrasquead",
	"churruscad",
	"chusmead",
	"chutad",
	"chuzad",
	"ciad",
	"ciberacosad",
	"cicatrizad",
	"cifrad",
	"cilindrad",
	"cimad",
	"cimblad",
	"cimbrad",
	"cimbread",
	"cimentad",
	"cincelad",
	"cinchad",
	"cinematografiad",
	"cinglad",
	"cintilad",
	"circuid",
	"circulad",
	"circuncidad",
	"circundad",
	"circunferid",
	"circunnavegad",
	"circunscript",
	"circunscrit",
	"circunstanciad",
	"circunvalad",
	"circunvenid",
	"circunvolad",
	"ciscad",
	"citad",
	"ciudadanizad",
	"civilizad",
	"cizallad",
	"cizañad",
	"cizañead",
	"clamad",
	"clamoread",
	"claread",
	"clarificad",
	"clasificad",
	"claudicad",
	"clausurad",
	"clavad",
	"clavetead",
	"clicad",
	"climatizad",
	"cliquead",
	"clocad",
	"clonad",
	"cloquead",
	"clorad",
	"clorinad",
	"cloroformizad",
	"coaccionad",
	"coactuad",
	"coadyuvad",
	"coagulad",
	"coaligad",
	"coanimad",
	"coartad",
	"coauspiciad",
	"cobijad",
	"cobrad",
	"cocead",
	"cocid",
	"cocinad",
	"cocread",
	"codead",
	"codesarrollad",
	"codescubiert",
	"codiciad",
	"codificad",
	"codirigid",
	"coeditad",
	"coescript",
	"coescrit",
	"coestructurad",
	"coevolucionad",
	"coexistid",
	"cofabricad",
	"cofinanciad",
	"cofundad",
	"cogid",
	"cogitad",
	"cogobernad",
	"cohabitad",
	"cohechad",
	"cohesionad",
	"cohibid",
	"cohondid",
	"cohonestad",
	"coimead",
	"coincidid",
	"cojead",
	"colaborad",
	"colad",
	"colapsad",
	"colchad",
	"colead",
	"coleccionad",
	"colectad",
	"colectivizad",
	"colegiad",
	"colegid",
	"coleguead",
	"colgad",
	"colidid",
	"coligad",
	"colimad",
	"colindad",
	"colisionad",
	"colmad",
	"colmatad",
	"colocad",
	"colonizad",
	"colorad",
	"coloread",
	"colorid",
	"coludid",
	"columbrad",
	"columpiad",
	"comadread",
	"comandad",
	"combad",
	"combatid",
	"combinad",
	"comedid",
	"comentad",
	"comenzad",
	"comerciad",
	"comercializad",
	"cometid",
	"comid",
	"comisad",
	"comisariad",
	"comiscad",
	"comisionad",
	"comisquead",
	"compactad",
	"compadecid",
	"compadrad",
	"compadread",
	"compaginad",
	"comparad",
	"comparecid",
	"compartid",
	"compartimentad",
	"compartimentalizad",
	"compasad",
	"compatibilizad",
	"compelid",
	"compendiad",
	"compenetrad",
	"compensad",
	"competid",
	"compilad",
	"compinchad",
	"complacid",
	"complejizad",
	"complementad",
	"completad",
	"complicad",
	"complotad",
	"comportad",
	"compostad",
	"comprad",
	"comprehendid",
	"comprendid",
	"comprimid",
	"comprobad",
	"comprometid",
	"compuest",
	"compulsad",
	"compungid",
	"compurgad",
	"computad",
	"computarizad",
	"computerizad",
	"comulgad",
	"comunicad",
	"comunitarizad",
	"concadenad",
	"concatenad",
	"concebid",
	"concedid",
	"concelebrad",
	"concentrad",
	"conceptuad",
	"conceptualizad",
	"concernid",
	"concertad",
	"concesionad",
	"conchabad",
	"concienciad",
	"concientizad",
	"conciliad",
	"concitad",
	"concluid",
	"concordad",
	"concretad",
	"concretizad",
	"conculcad",
	"concurrid",
	"concursad",
	"condecorad",
	"condenad",
	"condensad",
	"condesad",
	"condescendid",
	"condich",
	"condicionad",
	"condimentad",
	"condolid",
	"condonad",
	"conducid",
	"conectad",
	"conexionad",
	"confabulad",
	"confeccionad",
	"confederad",
	"conferenciad",
	"conferid",
	"confesad",
	"confiad",
	"configurad",
	"confinad",
	"confirmad",
	"confiscad",
	"confitad",
	"conflictuad",
	"confligid",
	"confluid",
	"conformad",
	"confortad",
	"confraternizad",
	"confrontad",
	"confundid",
	"congelad",
	"congeniad",
	"congestionad",
	"conglomerad",
	"congojad",
	"congraciad",
	"congratulad",
	"congregad",
	"conhortad",
	"conjeturad",
	"conjugad",
	"conjuntad",
	"conjurad",
	"conllevad",
	"conmemorad",
	"conmensurad",
	"conminad",
	"conmocionad",
	"conmovid",
	"conmutad",
	"connaturalizad",
	"connotad",
	"conocid",
	"conquistad",
	"consagrad",
	"conseguid",
	"consejad",
	"consensuad",
	"consentid",
	"conservad",
	"considerad",
	"consignad",
	"consistid",
	"consolad",
	"consolidad",
	"consonad",
	"consorciad",
	"conspirad",
	"constad",
	"constatad",
	"constelad",
	"consternad",
	"constipad",
	"constitucionalizad",
	"constituid",
	"constreñid",
	"construid",
	"consultad",
	"consumad",
	"consumid",
	"contabilizad",
	"contactad",
	"contad",
	"contagiad",
	"contaminad",
	"contemplad",
	"contemporizad",
	"contendid",
	"contenid",
	"contentad",
	"contestad",
	"contextuad",
	"contextualizad",
	"continuad",
	"contonead",
	"contornad",
	"contornead",
	"contorsionad",
	"contraargumentad",
	"contraatacad",
	"contrabalancead",
	"contrabandead",
	"contrademandad",
	"contradich",
	"contragolpead",
	"contrahech",
	"contraíd",
	"contraindicad",
	"contramandad",
	"contramarchad",
	"contrapesad",
	"contraprogramad",
	"contrapuest",
	"contrapuntead",
	"contrargumentad",
	"contrariad",
	"contrarrestad",
	"contrastad",
	"contratacad",
	"contratad",
	"contravenid",
	"contribuid",
	"contristad",
	"controlad",
	"controvertid",
	"contundid",
	"conturbad",
	"contusionad",
	"convalecid",
	"convalidad",
	"convencid",
	"convenid",
	"convergid",
	"conversad",
	"convertid",
	"convidad",
	"convivid",
	"convocad",
	"convulsionad",
	"conzederad",
	"cooperad",
	"cooperativizad",
	"cooptad",
	"coordenad",
	"coordinad",
	"coorganizad",
	"copad",
	"copatrocinad",
	"copead",
	"copetead",
	"copiad",
	"copilotad",
	"copresentad",
	"copresidid",
	"coproducid",
	"coprotagonizad",
	"copulad",
	"coquetead",
	"coquificad",
	"corcovead",
	"coread",
	"coreografiad",
	"corlad",
	"corlead",
	"cornead",
	"coronad",
	"corporizad",
	"corregid",
	"correlacionad",
	"correspondid",
	"corresponsabilizad",
	"corretead",
	"corrid",
	"corroborad",
	"corroíd",
	"corrompid",
	"corrugad",
	"cortad",
	"cortejad",
	"cortocircuitad",
	"corvad",
	"coscad",
	"cosechad",
	"cosid",
	"cosificad",
	"cosmetizad",
	"cosquillead",
	"costad",
	"costead",
	"cotejad",
	"cotillead",
	"cotizad",
	"cotorread",
	"crackead",
	"cranead",
	"cread",
	"crecid",
	"creíd",
	"cremad",
	"creosotad",
	"crepitad",
	"crespad",
	"crevad",
	"criad",
	"cribad",
	"criminad",
	"criminalizad",
	"crinad",
	"criogenizad",
	"criopreservad",
	"crismad",
	"crispad",
	"cristalizad",
	"cristianad",
	"cristianizad",
	"cristinead",
	"criticad",
	"croad",
	"cromad",
	"cronificad",
	"cronometrad",
	"crotorad",
	"crotoread",
	"crucificad",
	"crujid",
	"cruzad",
	"cuadrad",
	"cuadriculad",
	"cuadriplicad",
	"cuadruplicad",
	"cuajad",
	"cualificad",
	"cuantificad",
	"cuantizad",
	"cuartead",
	"cuartelad",
	"cuatriplicad",
	"cubanizad",
	"cubicad",
	"cubiert",
	"cubijad",
	"cuchad",
	"cucharead",
	"cuchichead",
	"cuchuchead",
	"cueread",
	"cuerpead",
	"cuestionad",
	"cuetead",
	"cuidad",
	"cuitad",
	"culead",
	"culebread",
	"culiad",
	"culminad",
	"culpabilizad",
	"culpad",
	"cultivad",
	"culturad",
	"culturalizad",
	"culturizad",
	"cumplid",
	"cumplimentad",
	"cumulad",
	"cundid",
	"cunead",
	"cuñad",
	"cuotead",
	"curad",
	"curiosead",
	"currad",
	"currelad",
	"cursad",
	"curtid",
	"curvad",
	"curvead",
	"custodiad",
	"customizad",
	"dactilografiad",
	"dad",
	"damnificad",
	"danzad",
	"dañad",
	"dañinead",
	"darlusad",
	"datad",
	"datead",
	"deambulad",
	"debatid",
	"debelad",
	"debid",
	"debilitad",
	"debitad",
	"debutad",
	"decaíd",
	"decantad",
	"decapad",
	"decapitad",
	"decebid",
	"decelerad",
	"decepcionad",
	"decidid",
	"decimalizad",
	"declamad",
	"declarad",
	"declinad",
	"decodificad",
	"decolad",
	"decolorad",
	"decomisad",
	"decomisionad",
	"deconstruid",
	"decorad",
	"decrecid",
	"decrementad",
	"decretad",
	"decuplad",
	"decuplicad",
	"decusad",
	"dedead",
	"dedicad",
	"deducid",
	"defecad",
	"defeccionad",
	"defendid",
	"defenestrad",
	"defensad",
	"deferid",
	"definid",
	"deflagrad",
	"deflectad",
	"deflorad",
	"defoliad",
	"deforestad",
	"deformad",
	"defosforilad",
	"defraudad",
	"degenerad",
	"deglutid",
	"degollad",
	"degradad",
	"degustad",
	"deificad",
	"dejad",
	"delaminad",
	"delatad",
	"delegad",
	"deleitad",
	"deletread",
	"deleznad",
	"delgazad",
	"deliberad",
	"delimitad",
	"delinead",
	"delinquid",
	"delirad",
	"deludid",
	"demacrad",
	"demandad",
	"demaquillad",
	"demarcad",
	"demarrad",
	"demediad",
	"demeritad",
	"democratizad",
	"demodulad",
	"demolid",
	"demonizad",
	"demorad",
	"demostrad",
	"demudad",
	"denegad",
	"denigrad",
	"denodad",
	"denominad",
	"denostad",
	"denotad",
	"densificad",
	"dentad",
	"dentellead",
	"dentrad",
	"denudad",
	"denunciad",
	"deparad",
	"departid",
	"depauperad",
	"dependid",
	"depilad",
	"deplorad",
	"deportad",
	"depositad",
	"depravad",
	"deprecad",
	"depreciad",
	"depredad",
	"deprimid",
	"depuest",
	"depurad",
	"deputad",
	"derechizad",
	"derelinquid",
	"derivad",
	"derogad",
	"derramad",
	"derrapad",
	"derrelinquid",
	"derrengad",
	"derretid",
	"derribad",
	"derrocad",
	"derrochad",
	"derrot",
	"derrotad",
	"derruid",
	"derrumbad",
	"desabastecid",
	"desabejad",
	"desabotonad",
	"desabrid",
	"desabrigad",
	"desabrochad",
	"desacatad",
	"desacelerad",
	"desacertad",
	"desacomodad",
	"desaconsejad",
	"desacoplad",
	"desacordad",
	"desacostumbrad",
	"desacralizad",
	"desacreditad",
	"desactivad",
	"desactualizad",
	"desaduanizad",
	"desafectad",
	"desafiad",
	"desafilad",
	"desafiliad",
	"desafinad",
	"desaforad",
	"desagotad",
	"desagradad",
	"desagradecid",
	"desagraviad",
	"desagregad",
	"desaguad",
	"desahijad",
	"desahogad",
	"desahuciad",
	"desainad",
	"desairad",
	"desajustad",
	"desalad",
	"desalentad",
	"desalinead",
	"desalinizad",
	"desaliñad",
	"desalmacenad",
	"desalojad",
	"desalquilad",
	"desamad",
	"desamarrad",
	"desambiguad",
	"desamistad",
	"desamortizad",
	"desamparad",
	"desandad",
	"desangrad",
	"desanimad",
	"desanudad",
	"desapalancad",
	"desaparead",
	"desaparecid",
	"desapasionad",
	"desapegad",
	"desaplicad",
	"desaprendid",
	"desaprobad",
	"desaprovechad",
	"desarbolad",
	"desarchivad",
	"desarenad",
	"desarmad",
	"desarraigad",
	"desarreglad",
	"desarrollad",
	"desarropad",
	"desarrugad",
	"desarticulad",
	"desasid",
	"desasnad",
	"desasosegad",
	"desatad",
	"desatascad",
	"desatendid",
	"desatentad",
	"desatinad",
	"desatornillad",
	"desatracad",
	"desatraillad",
	"desatrancad",
	"desautorizad",
	"desavenid",
	"desayunad",
	"desazolvad",
	"desazonad",
	"desballestad",
	"desbancad",
	"desbandad",
	"desbarajustad",
	"desbaratad",
	"desbarrad",
	"desbarrancad",
	"desbastad",
	"desbloquead",
	"desbocad",
	"desbordad",
	"desbotonad",
	"desbravad",
	"desbrozad",
	"descabalgad",
	"descabellad",
	"descabezad",
	"descachad",
	"descachimbad",
	"descaecid",
	"descafeinad",
	"descalabrad",
	"descalibrad",
	"descalificad",
	"descalzad",
	"descambiad",
	"descaminad",
	"descampad",
	"descansad",
	"descapitalizad",
	"descarad",
	"descarapelad",
	"descarbonatad",
	"descarbonizad",
	"descarboxilad",
	"descargad",
	"descarnad",
	"descarriad",
	"descarrilad",
	"descartad",
	"descasad",
	"descascarad",
	"descascarillad",
	"descastad",
	"descatalogad",
	"descendid",
	"descentrad",
	"descentralizad",
	"desceñid",
	"descerebrad",
	"descerrajad",
	"descertificad",
	"deschavad",
	"deschongad",
	"descifrad",
	"desclasad",
	"desclasificad",
	"desclavad",
	"descobijad",
	"descocad",
	"descocid",
	"descodificad",
	"descogid",
	"descogollad",
	"descohesionad",
	"descojonad",
	"descolgad",
	"descollad",
	"descolocad",
	"descolonizad",
	"descombrad",
	"descomedid",
	"descomid",
	"descompensad",
	"descompilad",
	"descompresionad",
	"descomprimid",
	"descompuest",
	"descomulgad",
	"desconcentrad",
	"desconceptuad",
	"desconcertad",
	"desconchad",
	"desconectad",
	"desconfiad",
	"descongelad",
	"descongestionad",
	"desconocid",
	"desconsagrad",
	"desconsiderad",
	"desconsolad",
	"desconsolidad",
	"descontad",
	"descontaminad",
	"descontentad",
	"descontextualizad",
	"descontinuad",
	"descontracturad",
	"descontratad",
	"descontrolad",
	"desconvenid",
	"desconvocad",
	"descoordinad",
	"descorazonad",
	"descorchad",
	"descordad",
	"descornad",
	"descorrid",
	"descortezad",
	"descosid",
	"descostillad",
	"descoyuntad",
	"descreíd",
	"descriminalizad",
	"descript",
	"descrit",
	"descruzad",
	"descuadrad",
	"descuajad",
	"descualificad",
	"descuartizad",
	"descubiert",
	"descuidad",
	"desdeñad",
	"desdibujad",
	"desdich",
	"desdoblad",
	"desdolarizad",
	"desdorad",
	"desdramatizad",
	"desead",
	"desecad",
	"desechad",
	"desembalad",
	"desembalsad",
	"desembarazad",
	"desembarcad",
	"desembargad",
	"desembarrancad",
	"desembocad",
	"desembolsad",
	"desembolsillad",
	"desemborrachad",
	"desembozad",
	"desembragad",
	"desembrollad",
	"desembrujad",
	"desembuchad",
	"desempacad",
	"desempalmad",
	"desempañad",
	"desempaquetad",
	"desempatad",
	"desempedrad",
	"desempeñad",
	"desempolvad",
	"desenamorad",
	"desencabestrad",
	"desencadenad",
	"desencajad",
	"desencallad",
	"desencaminad",
	"desencantad",
	"desencasillad",
	"desencerrad",
	"desenchufad",
	"desenclavad",
	"desencontrad",
	"desencorsetad",
	"desencorvad",
	"desencriptad",
	"desendeudad",
	"desenfadad",
	"desenfardelad",
	"desenfocad",
	"desenfrenad",
	"desenfundad",
	"desenganchad",
	"desengañad",
	"desengrasad",
	"desenlazad",
	"desenmarañad",
	"desenmascarad",
	"desenojad",
	"desenredad",
	"desenrollad",
	"desenroscad",
	"desensamblad",
	"desensibilizad",
	"desensillad",
	"desentendid",
	"desenterrad",
	"desentonad",
	"desentrañad",
	"desentubad",
	"desentumecid",
	"desenvainad",
	"desenvuelt",
	"desequilibrad",
	"desertad",
	"desertificad",
	"desertizad",
	"desescalad",
	"desescolarizad",
	"desescombrad",
	"desesperad",
	"desesperanzad",
	"desestabilizad",
	"desestacionalizad",
	"desestimad",
	"desestimulad",
	"desestresad",
	"desestructurad",
	"desfalcad",
	"desfallecid",
	"desfasad",
	"desfascistizad",
	"desfavorecid",
	"desfigurad",
	"desfilad",
	"desfinanciad",
	"desflecad",
	"desflorad",
	"desfogad",
	"desfondad",
	"desforzad",
	"desfragmentad",
	"desgajad",
	"desganad",
	"desgañitad",
	"desgarrad",
	"desgastad",
	"desglasad",
	"desglosad",
	"desgobernad",
	"desgonzad",
	"desgraciad",
	"desgranad",
	"desgravad",
	"desguanguañad",
	"desguarnecid",
	"desguazad",
	"desgubernamentalizad",
	"desguinzad",
	"deshabilitad",
	"deshabitad",
	"deshabituad",
	"deshebrad",
	"deshech",
	"deshelad",
	"desheredad",
	"deshidratad",
	"deshidrogenizad",
	"deshilachad",
	"deshilad",
	"deshilvanad",
	"deshinchad",
	"deshojad",
	"deshonorad",
	"deshonrad",
	"deshuesad",
	"deshumanizad",
	"deshumidificad",
	"desidentificad",
	"desideologizad",
	"designad",
	"desilusionad",
	"desimpresionad",
	"desimputad",
	"desincentivad",
	"desincorporad",
	"desincronizad",
	"desincrustad",
	"desindustrializad",
	"desinfectad",
	"desinflad",
	"desinflamad",
	"desinformad",
	"desinhibid",
	"desinsectad",
	"desinstalad",
	"desintegrad",
	"desinteresad",
	"desintoxicad",
	"desinvertid",
	"desionizad",
	"desistid",
	"desjarretad",
	"desjudicializad",
	"deslastrad",
	"deslavad",
	"deslazad",
	"deslegitimad",
	"desleíd",
	"deslenguad",
	"desliad",
	"desligad",
	"deslindad",
	"deslizad",
	"deslocalizad",
	"deslomad",
	"deslucid",
	"deslumbrad",
	"deslustrad",
	"desmadejad",
	"desmadrad",
	"desmalezad",
	"desmandad",
	"desmantelad",
	"desmaquillad",
	"desmarcad",
	"desmarimbad",
	"desmasculinizad",
	"desmaterializad",
	"desmayad",
	"desmedid",
	"desmedrad",
	"desmejorad",
	"desmelenad",
	"desmembrad",
	"desmentid",
	"desmenuzad",
	"desmerecid",
	"desmeritad",
	"desmesurad",
	"desmigad",
	"desmigajad",
	"desmilitarizad",
	"desminad",
	"desmitificad",
	"desmochad",
	"desmoldad",
	"desmonetizad",
	"desmontad",
	"desmonterad",
	"desmoralizad",
	"desmoronad",
	"desmotad",
	"desmotivad",
	"desmovilizad",
	"desmuert",
	"desnacid",
	"desnacionalizad",
	"desnatad",
	"desnaturalizad",
	"desnivelad",
	"desnortad",
	"desnucad",
	"desnuclearizad",
	"desnudad",
	"desnutrid",
	"desobedecid",
	"desobligad",
	"desobstruid",
	"desoccidentalizad",
	"desocupad",
	"desodorizad",
	"desoíd",
	"desolad",
	"desoldad",
	"desollad",
	"desorbitad",
	"desordenad",
	"desorejad",
	"desorganizad",
	"desorientad",
	"desornamentad",
	"desosad",
	"desosegad",
	"desovad",
	"desovillad",
	"desoxigenad",
	"despabilad",
	"despachad",
	"despachurrad",
	"despampanad",
	"despanzurrad",
	"desparasitad",
	"desparecid",
	"desparpajad",
	"desparramad",
	"despartidizad",
	"despatarrad",
	"despechad",
	"despedazad",
	"despedid",
	"despegad",
	"despeinad",
	"despejad",
	"despellejad",
	"despelotad",
	"despeluzad",
	"despenad",
	"despenalizad",
	"despeñad",
	"despepitad",
	"desperad",
	"despercudid",
	"desperdiciad",
	"desperdigad",
	"desperecid",
	"desperezad",
	"despersonalizad",
	"despertad",
	"despezad",
	"despicad",
	"despiezad",
	"despilfarrad",
	"despintad",
	"despiojad",
	"despistad",
	"desplantad",
	"desplazad",
	"desplegad",
	"desplomad",
	"desplumad",
	"despoblad",
	"despoetizad",
	"despojad",
	"despolarizad",
	"despolitizad",
	"despollad",
	"despolvad",
	"despolvoread",
	"desportillad",
	"desposad",
	"desposeíd",
	"despotizad",
	"despotricad",
	"despreciad",
	"desprecintad",
	"desprendid",
	"despreocupad",
	"desprestigiad",
	"desprivatizad",
	"desprofesionalizad",
	"desprogramad",
	"desprotegid",
	"desprotonad",
	"desproveíd",
	"desprovist",
	"despuntad",
	"desquebrajad",
	"desquiciad",
	"desquitad",
	"desrabad",
	"desrabotad",
	"desratizad",
	"desregulad",
	"desregularizad",
	"destacad",
	"destapad",
	"destartalad",
	"destazad",
	"destechad",
	"destejid",
	"destellad",
	"destemplad",
	"destendid",
	"destensad",
	"desteñid",
	"desternillad",
	"desterrad",
	"destetad",
	"destilad",
	"destinad",
	"destituid",
	"destocad",
	"destorcid",
	"destornillad",
	"destorvad",
	"destrabad",
	"destrancad",
	"destratad",
	"destrenzad",
	"destrepad",
	"destripad",
	"destrocad",
	"destronad",
	"destroncad",
	"destrozad",
	"destruid",
	"destupid",
	"desturcad",
	"desubicad",
	"desunid",
	"desuscript",
	"desuscrit",
	"desvaíd",
	"desvainad",
	"desvalijad",
	"desvalorizad",
	"desvanecid",
	"desvariad",
	"desvasad",
	"desvelad",
	"desvenad",
	"desvencijad",
	"desventad",
	"desventajad",
	"desventrad",
	"desvertebrad",
	"desvestid",
	"desviad",
	"desvinculad",
	"desvirgad",
	"desvirtuad",
	"desvivid",
	"detallad",
	"detectad",
	"detenid",
	"detentad",
	"detergid",
	"deteriorad",
	"determinad",
	"detestad",
	"detonad",
	"detoxificad",
	"detraíd",
	"deturpad",
	"devaluad",
	"devanad",
	"devastad",
	"develad",
	"devengad",
	"devenid",
	"devid",
	"devisad",
	"devorad",
	"devuelt",
	"dexad",
	"dezmad",
	"diabolizad",
	"diafragmad",
	"diagnosticad",
	"diagonalizad",
	"diagramad",
	"dializad",
	"dialogad",
	"diamantad",
	"dibujad",
	"dich",
	"dicotomizad",
	"dictad",
	"dictaminad",
	"dietad",
	"diezmad",
	"difamad",
	"diferenciad",
	"diferid",
	"dificultad",
	"difractad",
	"difuminad",
	"difundid",
	"digerid",
	"digitad",
	"digitalizad",
	"dignad",
	"dignificad",
	"dilapidad",
	"dilatad",
	"diligenciad",
	"dilucidad",
	"diluid",
	"dimanad",
	"dimensionad",
	"dimerizad",
	"dimidiad",
	"dimisionad",
	"dimitid",
	"dinamitad",
	"dinamizad",
	"diñad",
	"diplomad",
	"dippead",
	"diptongad",
	"diputad",
	"direccionad",
	"dirigid",
	"dirimid",
	"discad",
	"discapacitad",
	"discernid",
	"disciplinad",
	"discontinuad",
	"discordad",
	"discrepad",
	"discretead",
	"discriminad",
	"disculpad",
	"discurrid",
	"discursad",
	"discursead",
	"discutid",
	"disecad",
	"diseccionad",
	"disectad",
	"diseminad",
	"disentid",
	"diseñad",
	"disertad",
	"disfamad",
	"disfrazad",
	"disfrutad",
	"disgregad",
	"disgustad",
	"disimulad",
	"disipad",
	"dislocad",
	"disminuid",
	"disociad",
	"disonad",
	"disparad",
	"disparatad",
	"dispensad",
	"dispensarizad",
	"dispersad",
	"dispuest",
	"disputad",
	"distad",
	"distanciad",
	"distendid",
	"distilad",
	"distinguid",
	"distorsionad",
	"distraíd",
	"distribuid",
	"disturbad",
	"disuadid",
	"disuelt",
	"divagad",
	"divergid",
	"diversificad",
	"divertid",
	"dividid",
	"divinad",
	"divinizad",
	"divisad",
	"divorciad",
	"divulgad",
	"doblad",
	"doblegad",
	"dobletead",
	"doctorad",
	"doctrinad",
	"documentad",
	"dogmatizad",
	"dolad",
	"dolarizad",
	"dolid",
	"domad",
	"domeñad",
	"domesticad",
	"domiciliad",
	"dominad",
	"donad",
	"doñead",
	"dopad",
	"dorad",
	"dormid",
	"dormitad",
	"dosificad",
	"dotad",
	"dovelad",
	"draftead",
	"dragad",
	"dragonead",
	"dramatizad",
	"drapead",
	"drenad",
	"driblad",
	"driblead",
	"drogad",
	"dubdad",
	"duchad",
	"dudad",
	"dulcificad",
	"duplicad",
	"durad",
	"echad",
	"eclipsad",
	"eclosionad",
	"economizad",
	"ecualizad",
	"edificad",
	"editad",
	"editorializad",
	"educad",
	"educid",
	"edulcorad",
	"efectivizad",
	"efectuad",
	"efeminad",
	"eficientad",
	"eficientizad",
	"efundid",
	"egresad",
	"ejecutad",
	"ejecutoriad",
	"ejemplarizad",
	"ejemplificad",
	"ejercid",
	"ejercitad",
	"elaborad",
	"elect",
	"electoralizad",
	"electrificad",
	"electrizad",
	"electrocutad",
	"elegid",
	"elevad",
	"elidid",
	"eligid",
	"elijad",
	"eliminad",
	"elogiad",
	"elongad",
	"elucidad",
	"elucubrad",
	"eludid",
	"eluid",
	"emanad",
	"emancipad",
	"emasculad",
	"embadurnad",
	"embaíd",
	"embalad",
	"embaldosad",
	"embalsad",
	"embalsamad",
	"embanderad",
	"embarazad",
	"embarcad",
	"embargad",
	"embarrad",
	"embarrancad",
	"embarullad",
	"embasad",
	"embastad",
	"embaucad",
	"embaulad",
	"embazad",
	"embebecid",
	"embebid",
	"embejucad",
	"embelecad",
	"embelesad",
	"embellecid",
	"embestid",
	"embetunad",
	"emblanquecid",
	"embobad",
	"embocad",
	"embodegad",
	"embolad",
	"embolizad",
	"embolsad",
	"embolsillad",
	"embonad",
	"emboquillad",
	"emborrachad",
	"emborronad",
	"emboscad",
	"embotad",
	"embotellad",
	"embovedad",
	"embozad",
	"embozalad",
	"embragad",
	"embravecid",
	"embrazad",
	"embread",
	"embretad",
	"embriagad",
	"embridad",
	"embrollad",
	"embromad",
	"embrujad",
	"embrutecid",
	"embuchad",
	"embullad",
	"embustead",
	"embustid",
	"embutid",
	"emendad",
	"emergid",
	"emigrad",
	"emitid",
	"emocionad",
	"empacad",
	"empachad",
	"empadronad",
	"empalad",
	"empalagad",
	"empalidecid",
	"empalizad",
	"empalmad",
	"empanad",
	"empanizad",
	"empantanad",
	"empañad",
	"empapad",
	"empapelad",
	"empapuciad",
	"empapuzad",
	"empaquetad",
	"emparedad",
	"emparejad",
	"emparentad",
	"emparrillad",
	"empastad",
	"empastillad",
	"empatad",
	"empatizad",
	"empavad",
	"empavesad",
	"empecid",
	"empecinad",
	"empedernid",
	"empedrad",
	"empelad",
	"empellad",
	"empellid",
	"empenachad",
	"empeñad",
	"empeorad",
	"empequeñecid",
	"emperad",
	"emperejilad",
	"emperifollad",
	"emperrad",
	"empezad",
	"empiltrad",
	"empinad",
	"empingorotad",
	"empitonad",
	"emplatad",
	"emplazad",
	"emplead",
	"emplomad",
	"emplumad",
	"empobrecid",
	"empoderad",
	"empodrecid",
	"empollad",
	"empolvad",
	"emponzoñad",
	"empotrad",
	"empozad",
	"emprendid",
	"empreñad",
	"emprestad",
	"emproblemad",
	"empujad",
	"empuñad",
	"emputad",
	"emputecid",
	"emulad",
	"emulgid",
	"emulsificad",
	"emulsionad",
	"emungid",
	"enajenad",
	"enalmagrad",
	"enaltecid",
	"enamorad",
	"enamoriscad",
	"enarbolad",
	"enarcad",
	"enardecid",
	"enarenad",
	"enastad",
	"enbiad",
	"encabad",
	"encabalgad",
	"encabestrad",
	"encabezad",
	"encabritad",
	"encabronad",
	"encachimbad",
	"encadenad",
	"encajad",
	"encajonad",
	"encalabozad",
	"encalabrinad",
	"encalad",
	"encallad",
	"encallecid",
	"encalmad",
	"encalzad",
	"encamad",
	"encaminad",
	"encandilad",
	"encanecid",
	"encantad",
	"encañonad",
	"encaperuzad",
	"encapotad",
	"encaprichad",
	"encapsulad",
	"encapuchad",
	"encapuzad",
	"encarad",
	"encaramad",
	"encarcelad",
	"encarecid",
	"encargad",
	"encariñad",
	"encarnad",
	"encarnecid",
	"encarnizad",
	"encarrilad",
	"encartad",
	"encasillad",
	"encasquetad",
	"encasquillad",
	"encastad",
	"encastillad",
	"encastrad",
	"encatusad",
	"encausad",
	"encauzad",
	"encebad",
	"enceguecid",
	"encelad",
	"encenagad",
	"encendid",
	"encenizad",
	"encerad",
	"encerrad",
	"encestad",
	"encetad",
	"enchachad",
	"enchapad",
	"enchapopotad",
	"encharcad",
	"enchilad",
	"enchinad",
	"enchiquerad",
	"enchironad",
	"enchuecad",
	"enchufad",
	"enchuflad",
	"enchulad",
	"encimad",
	"encintad",
	"enclaustrad",
	"enclavad",
	"encofrad",
	"encogid",
	"encolad",
	"encolerizad",
	"encolumnad",
	"encomendad",
	"encomenzad",
	"encomiad",
	"enconad",
	"enconchad",
	"encontrad",
	"encoñad",
	"encopetad",
	"encorajinad",
	"encorazad",
	"encordad",
	"encornudad",
	"encorsetad",
	"encorvad",
	"encostad",
	"encostalad",
	"encrespad",
	"encriptad",
	"encuadernad",
	"encuadrad",
	"encuartelad",
	"encubad",
	"encubertad",
	"encubiert",
	"encuclillad",
	"encuerad",
	"encuestad",
	"enculad",
	"encumbrad",
	"encunetad",
	"encurtid",
	"endechad",
	"endemoniad",
	"enderezad",
	"endeudad",
	"endiablad",
	"endilgad",
	"endiñad",
	"endiosad",
	"endomingad",
	"endosad",
	"endrogad",
	"endulzad",
	"endurecid",
	"enemistad",
	"energizad",
	"enervad",
	"enfadad",
	"enfangad",
	"enfardad",
	"enfatizad",
	"enfebrecid",
	"enfermad",
	"enfervorizad",
	"enfeudad",
	"enfilad",
	"enflacad",
	"enflaquecid",
	"enflorad",
	"enfocad",
	"enforcad",
	"enfoscad",
	"enfrascad",
	"enfrenad",
	"enfrentad",
	"enfriad",
	"enfrontad",
	"enfundad",
	"enfurecid",
	"enfurruñad",
	"engalanad",
	"engalgad",
	"engallad",
	"enganchad",
	"engangrenad",
	"engañad",
	"engarruchad",
	"engarzad",
	"engastad",
	"engatillad",
	"engatusad",
	"engavetad",
	"engendrad",
	"englobad",
	"engolfad",
	"engolondrinad",
	"engolosinad",
	"engomad",
	"engominad",
	"engordad",
	"engranad",
	"engrandad",
	"engrandecid",
	"engrapad",
	"engrasad",
	"engravecid",
	"engreíd",
	"engrillad",
	"engrilletad",
	"engrosad",
	"engrudad",
	"engruesad",
	"engrupid",
	"enguacalad",
	"enguantad",
	"enguatad",
	"enguirnaldad",
	"engullid",
	"enharinad",
	"enhebrad",
	"enherbolad",
	"enhilad",
	"enhornad",
	"enjabonad",
	"enjaezad",
	"enjaguad",
	"enjalbegad",
	"enjalmad",
	"enjambrad",
	"enjaretad",
	"enjaulad",
	"enjoyad",
	"enjuagad",
	"enjugad",
	"enjuiciad",
	"enjuncad",
	"enjutad",
	"enlaciad",
	"enladrillad",
	"enlatad",
	"enlazad",
	"enlentecid",
	"enlenzad",
	"enlistad",
	"enlodad",
	"enloquecid",
	"enlosad",
	"enlozad",
	"enlucid",
	"enlutad",
	"enmaderad",
	"enmadrad",
	"enmallad",
	"enmanillad",
	"enmarañad",
	"enmarcad",
	"enmarrocad",
	"enmascarad",
	"enmasillad",
	"enmendad",
	"enmohecid",
	"enmoquetad",
	"enmudecid",
	"enmugrad",
	"ennegrecid",
	"ennoblecid",
	"enojad",
	"enorgullecid",
	"enquistad",
	"enrabietad",
	"enracimad",
	"enraizad",
	"enramad",
	"enranciad",
	"enrarecid",
	"enrasad",
	"enratonad",
	"enredad",
	"enrejad",
	"enrevesad",
	"enrielad",
	"enripiad",
	"enriquecid",
	"enriscad",
	"enristrad",
	"enrocad",
	"enrojecid",
	"enrolad",
	"enrollad",
	"enronquecid",
	"enroscad",
	"enrostrad",
	"enrubiad",
	"enrumbad",
	"enrutad",
	"ensalzad",
	"ensamblad",
	"ensanchad",
	"ensangrentad",
	"ensañad",
	"ensartad",
	"ensayad",
	"ensebad",
	"ensecad",
	"enseñad",
	"enseñoread",
	"ensillad",
	"ensimismad",
	"ensoberbecid",
	"ensobrad",
	"ensogad",
	"ensombrecid",
	"ensoñad",
	"ensopad",
	"ensordecid",
	"ensortijad",
	"ensuciad",
	"entablad",
	"entablillad",
	"entallad",
	"entapizad",
	"entecad",
	"entendid",
	"entenebrecid",
	"enterad",
	"entercad",
	"enternecid",
	"enterrad",
	"entesad",
	"entibiad",
	"entiesad",
	"entintad",
	"entoldad",
	"entomatad",
	"entonad",
	"entontecid",
	"entorchad",
	"entornad",
	"entorpecid",
	"entortijad",
	"entrabad",
	"entrad",
	"entramad",
	"entrampad",
	"entrañad",
	"entreabiert",
	"entrecerrad",
	"entrechocad",
	"entrecomillad",
	"entrecortad",
	"entrecruzad",
	"entredich",
	"entregad",
	"entrelazad",
	"entremetid",
	"entremezclad",
	"entrenad",
	"entreoíd",
	"entresacad",
	"entretejid",
	"entretenid",
	"entrevenid",
	"entreverad",
	"entrevist",
	"entrevistad",
	"entripad",
	"entristecid",
	"entrojad",
	"entrometid",
	"entronad",
	"entroncad",
	"entronizad",
	"entropezad",
	"entrujad",
	"entubad",
	"entumecid",
	"entunicad",
	"enturbiad",
	"entusiasmad",
	"enumerad",
	"enunciad",
	"envainad",
	"envalentonad",
	"envanecid",
	"envarad",
	"envasad",
	"envejecid",
	"envenenad",
	"envergad",
	"envergonzad",
	"envestid",
	"enviad",
	"enviciad",
	"envidad",
	"envidiad",
	"envigad",
	"envilecid",
	"enviscad",
	"enviudad",
	"envuelt",
	"enyerbad",
	"enyesad",
	"enzacatad",
	"enzarzad",
	"epatad",
	"epitomad",
	"equidistad",
	"equilibrad",
	"equipad",
	"equiparad",
	"equivalid",
	"equivocad",
	"erguid",
	"erigid",
	"erizad",
	"erogad",
	"erosionad",
	"erotizad",
	"errad",
	"erradicad",
	"eructad",
	"erupcionad",
	"esbarad",
	"esbozad",
	"escabechad",
	"escabiad",
	"escabullid",
	"escachad",
	"escaecid",
	"escalad",
	"escaldad",
	"escalentad",
	"escalfad",
	"escalofriad",
	"escalonad",
	"escamad",
	"escamotead",
	"escampad",
	"escanciad",
	"escandalizad",
	"escandid",
	"escanead",
	"escapad",
	"escaquead",
	"escarabajead",
	"escaramuzad",
	"escarapelad",
	"escarbad",
	"escarchad",
	"escardad",
	"escariad",
	"escarificad",
	"escarmenad",
	"escarmentad",
	"escarnecid",
	"escarpad",
	"escasead",
	"escatimad",
	"escavad",
	"escayolad",
	"escenificad",
	"escenografiad",
	"escindid",
	"esclarecid",
	"esclavizad",
	"esclerosad",
	"esclerotizad",
	"escobad",
	"escobillad",
	"escocid",
	"escodad",
	"escofinad",
	"escogid",
	"escolarizad",
	"escoltad",
	"escombrad",
	"escondid",
	"escoplead",
	"escorad",
	"escoriad",
	"escorzad",
	"escotad",
	"escrachad",
	"escript",
	"escrit",
	"escriturad",
	"escrudiñad",
	"escrupulizad",
	"escrutad",
	"escuadrad",
	"escuadronad",
	"escuchad",
	"escudad",
	"escudriñad",
	"esculpid",
	"escupid",
	"escurrid",
	"escusad",
	"esencializad",
	"esfollad",
	"esforzad",
	"esfumad",
	"esgrafiad",
	"esgrimid",
	"esguazad",
	"eslabonad",
	"esleíd",
	"esmaltad",
	"esmerad",
	"esmerilad",
	"esmorecid",
	"esnifad",
	"espabilad",
	"espachurrad",
	"espaciad",
	"espacializad",
	"espantad",
	"españolizad",
	"esparcid",
	"espartad",
	"especiad",
	"especializad",
	"especificad",
	"especulad",
	"espejead",
	"espeluznad",
	"esperad",
	"esperanzad",
	"espesad",
	"espetad",
	"espiad",
	"espichad",
	"espigad",
	"espinad",
	"espirad",
	"espiritualizad",
	"esplanad",
	"esplendid",
	"esplicad",
	"espolead",
	"espoliad",
	"espolvoread",
	"esponjad",
	"esponsorizad",
	"espontanead",
	"esposad",
	"espresad",
	"esprintad",
	"espulgad",
	"espumad",
	"espumead",
	"esputad",
	"esquematizad",
	"esquiad",
	"esquilad",
	"esquilmad",
	"esquinad",
	"esquinzad",
	"esquivad",
	"estabilizad",
	"establecid",
	"estabulad",
	"estacad",
	"estacionad",
	"estacionalizad",
	"estad",
	"estafad",
	"estallad",
	"estampad",
	"estampillad",
	"estancad",
	"estandarizad",
	"estañad",
	"estaquillad",
	"estarcid",
	"estatizad",
	"estatuid",
	"estelarizad",
	"estendid",
	"esterad",
	"estercolad",
	"estereotipad",
	"esterificad",
	"esterilizad",
	"estetizad",
	"estibad",
	"estigmatizad",
	"estilad",
	"estilizad",
	"estimad",
	"estimulad",
	"estipulad",
	"estirad",
	"estofad",
	"estoquead",
	"estorbad",
	"estornudad",
	"estozolad",
	"estragad",
	"estrangulad",
	"estratificad",
	"estrechad",
	"estregad",
	"estrellad",
	"estremecid",
	"estrenad",
	"estreñid",
	"estresad",
	"estriad",
	"estribad",
	"estropead",
	"estruchad",
	"estructurad",
	"estrujad",
	"estucad",
	"estudiad",
	"esvarad",
	"eterizad",
	"eternizad",
	"etimologizad",
	"etiquetad",
	"etoxilad",
	"europeizad",
	"euscaldunizad",
	"euskaldunizad",
	"evacuad",
	"evadid",
	"evaluad",
	"evanescid",
	"evangelizad",
	"evaporad",
	"evidenciad",
	"eviscerad",
	"evitad",
	"evocad",
	"evolucionad",
	"exacerbad",
	"exagerad",
	"exaltad",
	"examinad",
	"exasperad",
	"excarcelad",
	"excavad",
	"excedid",
	"exceptuad",
	"excitad",
	"exclamad",
	"exclaustrad",
	"excluid",
	"excomulgad",
	"excoriad",
	"excretad",
	"exculpad",
	"excusad",
	"execrad",
	"executad",
	"exentad",
	"exercitad",
	"exfiltrad",
	"exfoliad",
	"exhalad",
	"exhibid",
	"exhortad",
	"exhumad",
	"exigid",
	"exilad",
	"exiliad",
	"eximid",
	"existid",
	"existimad",
	"exonerad",
	"exorcizad",
	"exornad",
	"expandid",
	"expansionad",
	"expatriad",
	"expectad",
	"expectorad",
	"expedicionad",
	"expedid",
	"expedientad",
	"expeditad",
	"expelid",
	"expendid",
	"experienciad",
	"experimentad",
	"expiad",
	"expirad",
	"explanad",
	"explayad",
	"explicad",
	"explicitad",
	"explorad",
	"explosionad",
	"explotad",
	"expoliad",
	"exponenciad",
	"exportad",
	"expresad",
	"exprimid",
	"expropiad",
	"expuest",
	"expugnad",
	"expulsad",
	"expurgad",
	"extasiad",
	"extendid",
	"extenuad",
	"exteriorizad",
	"exterminad",
	"externad",
	"externalizad",
	"extinguid",
	"extirpad",
	"extorsionad",
	"extractad",
	"extraditad",
	"extraíd",
	"extralimitad",
	"extrañad",
	"extrapolad",
	"extravasad",
	"extraviad",
	"extremad",
	"extrudid",
	"extruid",
	"extubad",
	"exudad",
	"exulcerad",
	"exultad",
	"eyaculad",
	"eyectad",
	"fabricad",
	"fabulad",
	"fachad",
	"facilitad",
	"factorizad",
	"facturad",
	"facultad",
	"faenad",
	"fagocitad",
	"fajad",
	"falagad",
	"falcacead",
	"faldead",
	"fallad",
	"fallecid",
	"fallid",
	"falsad",
	"falsead",
	"falsificad",
	"faltad",
	"familiarizad",
	"fanatizad",
	"fanfarronead",
	"fantasead",
	"fantasiad",
	"fantasmead",
	"farandulead",
	"fardad",
	"farfullad",
	"farolead",
	"farread",
	"fascinad",
	"fastidiad",
	"fatigad",
	"favelizad",
	"favorecid",
	"fech",
	"fechad",
	"fecundad",
	"fecundizad",
	"fedatad",
	"fedatead",
	"federad",
	"federalizad",
	"felicitad",
	"femad",
	"feminizad",
	"fenecid",
	"feriad",
	"fermentad",
	"ferrad",
	"fertilizad",
	"fervorizad",
	"festejad",
	"festinad",
	"festonad",
	"festonead",
	"fetichizad",
	"fiad",
	"fibrilad",
	"ficad",
	"ficcionad",
	"ficcionalizad",
	"fichad",
	"fidelizad",
	"figurad",
	"fijad",
	"filad",
	"fildead",
	"filetead",
	"filiad",
	"filmad",
	"filosofad",
	"filtrad",
	"finad",
	"finalizad",
	"financiad",
	"fincad",
	"fingid",
	"finid",
	"finiquitad",
	"fintad",
	"firmad",
	"fiscalizad",
	"fisgad",
	"fisgonead",
	"fisionad",
	"fisurad",
	"flagelad",
	"flambead",
	"flamead",
	"flanquead",
	"flaquead",
	"flechad",
	"fletad",
	"flexead",
	"flexibilizad",
	"flexionad",
	"flipad",
	"flirtead",
	"flojead",
	"florad",
	"floread",
	"florecid",
	"floretead",
	"flotad",
	"fluctuad",
	"fluid",
	"fluidizad",
	"fluorad",
	"focalizad",
	"foguead",
	"folgad",
	"foliad",
	"follad",
	"folletead",
	"fomentad",
	"fondead",
	"forcejad",
	"forcejead",
	"forestad",
	"forjad",
	"formad",
	"formalizad",
	"formatead",
	"formulad",
	"fornicad",
	"forrad",
	"forrajead",
	"fortalecid",
	"fortificad",
	"forzad",
	"fosfatad",
	"fosfatizad",
	"fosforecid",
	"fosforescid",
	"fosforilad",
	"fosilizad",
	"fotocopiad",
	"fotografiad",
	"fotoshopead",
	"fracasad",
	"fraccionad",
	"fracturad",
	"fragilizad",
	"fragmentad",
	"fraguad",
	"franelead",
	"frangid",
	"franjead",
	"franquead",
	"franquiciad",
	"frasead",
	"fraternizad",
	"frecuentad",
	"fregad",
	"fregotead",
	"freíd",
	"frenad",
	"frentead",
	"fresad",
	"frezad",
	"friccionad",
	"frisad",
	"frit",
	"fritad",
	"frivolizad",
	"frizad",
	"frotad",
	"fructificad",
	"fruid",
	"fruncid",
	"frustrad",
	"frutad",
	"fufad",
	"fugad",
	"fulgid",
	"fulgurad",
	"fulminad",
	"fumad",
	"fumblead",
	"fumigad",
	"funad",
	"funcionad",
	"fundad",
	"fundamentad",
	"fundid",
	"fungid",
	"fuñid",
	"furtad",
	"furulad",
	"fusilad",
	"fusionad",
	"fustigad",
	"gafad",
	"gaguead",
	"galantead",
	"galardonad",
	"galguead",
	"gallardead",
	"gallead",
	"gallofead",
	"galonead",
	"galopad",
	"galopead",
	"galvanizad",
	"gamberread",
	"gambetead",
	"ganad",
	"gandujad",
	"gandulead",
	"gangrenad",
	"ganguead",
	"gañid",
	"garabatead",
	"garantid",
	"garantizad",
	"garapiñad",
	"garbad",
	"garchad",
	"gargarizad",
	"garlad",
	"garpad",
	"garrapatead",
	"garrapiñad",
	"garronead",
	"garrotead",
	"gasead",
	"gasificad",
	"gastad",
	"gatead",
	"gatillad",
	"gayad",
	"gelatinizad",
	"gelificad",
	"gemid",
	"geminad",
	"generad",
	"generalizad",
	"genotipad",
	"gentrificad",
	"geobloquead",
	"geolocalizad",
	"georeferenciad",
	"georreferenciad",
	"gerenciad",
	"germanizad",
	"germinad",
	"gestad",
	"gesticulad",
	"gestionad",
	"gibad",
	"gilipollead",
	"gimotead",
	"girad",
	"giroelongad",
	"gitanead",
	"glasead",
	"globalizad",
	"gloriad",
	"glorificad",
	"glosad",
	"glotalizad",
	"glotonead",
	"gobernad",
	"golead",
	"golfead",
	"golosead",
	"golpead",
	"golpetead",
	"googlead",
	"gorgotead",
	"gorjead",
	"gorread",
	"gorronead",
	"gostead",
	"gotead",
	"gozad",
	"grabad",
	"gradad",
	"graduad",
	"graffitead",
	"graficad",
	"grafitead",
	"granad",
	"granead",
	"granizad",
	"granjead",
	"granulad",
	"grapad",
	"gratificad",
	"gratinad",
	"gravad",
	"gravitad",
	"graznad",
	"grillad",
	"griñotad",
	"gripad",
	"gritad",
	"gruñid",
	"guacaread",
	"guadañad",
	"guapead",
	"guarachead",
	"guardad",
	"guarecid",
	"guarid",
	"guarnecid",
	"guarnid",
	"guasapead",
	"guataquead",
	"guayad",
	"guerread",
	"guglead",
	"guiad",
	"guillotinad",
	"guinchad",
	"guindad",
	"guiñad",
	"guionad",
	"guionizad",
	"guisad",
	"guitarread",
	"gulusmead",
	"gustad",
	"habid",
	"habilitad",
	"habitad",
	"habituad",
	"hablad",
	"hacendad",
	"hachad",
	"hacinad",
	"hackead",
	"halad",
	"halagad",
	"hallad",
	"halogenad",
	"hamacad",
	"hamaquead",
	"hambread",
	"hanguead",
	"haraganead",
	"hartad",
	"hastiad",
	"hech",
	"hechizad",
	"hedid",
	"hegemonizad",
	"helad",
	"helenizad",
	"helitransportad",
	"henchid",
	"hendid",
	"heñid",
	"herbad",
	"herborizad",
	"heredad",
	"herid",
	"hermanad",
	"hermandad",
	"hermetizad",
	"hermosead",
	"herniad",
	"herrad",
	"herrumbrad",
	"hervid",
	"hesitad",
	"hibernad",
	"hibridad",
	"hidratad",
	"hidrogenad",
	"hidrolizad",
	"higienizad",
	"hilad",
	"hilvanad",
	"hincad",
	"hinchad",
	"hipad",
	"hiperactivad",
	"hiperbolizad",
	"hipertrofiad",
	"hiperventilad",
	"hipnotizad",
	"hipotecad",
	"hipotetizad",
	"hisopad",
	"hispanizad",
	"hispid",
	"historiad",
	"hocicad",
	"hociquead",
	"hojaldrad",
	"hojead",
	"holgad",
	"holgazanead",
	"hollad",
	"hombread",
	"homenajead",
	"homogeneizad",
	"homologad",
	"homosexualizad",
	"honestad",
	"honorad",
	"honrad",
	"horadad",
	"horizontalizad",
	"hormigonad",
	"hormiguead",
	"hornead",
	"horripilad",
	"horrorizad",
	"hospedad",
	"hospitalizad",
	"hostiad",
	"hostigad",
	"hostilizad",
	"hozad",
	"huevead",
	"huid",
	"humad",
	"humanad",
	"humanizad",
	"humead",
	"humectad",
	"humedecid",
	"humidificad",
	"humillad",
	"hundid",
	"hurgad",
	"huronead",
	"hurtad",
	"husmad",
	"husmead",
	"idead",
	"idealizad",
	"identificad",
	"ideologizad",
	"idiotizad",
	"idolatrad",
	"ignorad",
	"igualad",
	"ilegalizad",
	"ilegitimad",
	"iludid",
	"iluminad",
	"ilusionad",
	"ilustrad",
	"imaginad",
	"imanad",
	"imantad",
	"imbecilizad",
	"imbricad",
	"imbuid",
	"imitad",
	"impacientad",
	"impactad",
	"impagad",
	"impartid",
	"impedid",
	"impelid",
	"impendid",
	"imperad",
	"impermeabilizad",
	"impersonalizad",
	"impetrad",
	"implantad",
	"implementad",
	"implicad",
	"implorad",
	"implosionad",
	"importad",
	"importunad",
	"imposibilitad",
	"impostad",
	"imprecad",
	"impregnad",
	"impres",
	"impresionad",
	"imprimad",
	"imprimid",
	"improbad",
	"improvisad",
	"impuest",
	"impugnad",
	"impulsad",
	"impurificad",
	"imputad",
	"inactivad",
	"inadmitid",
	"inaugurad",
	"incapacitad",
	"incardinad",
	"incautad",
	"incendiad",
	"incensad",
	"incentivad",
	"incidentad",
	"incidid",
	"incinerad",
	"incitad",
	"inclinad",
	"incluid",
	"incoad",
	"incomodad",
	"incomunicad",
	"inconformad",
	"incordiad",
	"incorporad",
	"incrementad",
	"increpad",
	"incriminad",
	"incrustad",
	"incubad",
	"inculcad",
	"inculpad",
	"incumbid",
	"incumplid",
	"incurrid",
	"incursionad",
	"indagad",
	"indemnizad",
	"independizad",
	"indexad",
	"indicad",
	"indiciad",
	"indigestad",
	"indignad",
	"indisciplinad",
	"indispuest",
	"individualizad",
	"indizad",
	"inducid",
	"indultad",
	"industriad",
	"industrializad",
	"inejecutad",
	"inervad",
	"infamad",
	"infantilizad",
	"infartad",
	"infatuad",
	"infeccionad",
	"infectad",
	"inferid",
	"infestad",
	"infeudad",
	"inficionad",
	"infiltrad",
	"inflacionad",
	"inflad",
	"inflamad",
	"infligid",
	"influenciad",
	"influid",
	"informad",
	"informalizad",
	"informatizad",
	"infraccionad",
	"infraexplotad",
	"infrautilizad",
	"infravalorad",
	"infringid",
	"infundid",
	"infusionad",
	"ingeniad",
	"ingerid",
	"ingresad",
	"ingurgitad",
	"inhabilitad",
	"inhalad",
	"inhibid",
	"inhumad",
	"iniciad",
	"inicializad",
	"injerid",
	"injertad",
	"injuriad",
	"inmatriculad",
	"inmigrad",
	"inmiscuid",
	"inmolad",
	"inmortalizad",
	"inmovilizad",
	"inmunizad",
	"inmutad",
	"innovad",
	"inobservad",
	"inoculad",
	"inquietad",
	"inquinad",
	"inquirid",
	"inscript",
	"inscrit",
	"inseminad",
	"insensibilizad",
	"inserid",
	"insertad",
	"insidiad",
	"insinuad",
	"insistid",
	"insolentad",
	"insonorizad",
	"inspeccionad",
	"inspirad",
	"instad",
	"instalad",
	"instanciad",
	"instaurad",
	"instigad",
	"instilad",
	"institucionalizad",
	"instituid",
	"instruid",
	"instrumentad",
	"instrumentalizad",
	"insubordinad",
	"insuflad",
	"insultad",
	"insumid",
	"insurreccionad",
	"integrad",
	"inteligid",
	"intencionad",
	"intendid",
	"intensificad",
	"intentad",
	"interaccionad",
	"interactuad",
	"intercalad",
	"intercambiad",
	"intercedid",
	"interceptad",
	"intercomunicad",
	"interconectad",
	"interconvertid",
	"interdich",
	"interesad",
	"interferid",
	"interfoliad",
	"intergradad",
	"interiorizad",
	"interlocutad",
	"intermediad",
	"intermezclad",
	"internacionalizad",
	"internad",
	"internalizad",
	"interoperad",
	"interpelad",
	"interpolad",
	"interpretad",
	"interpuest",
	"interrelacionad",
	"interrogad",
	"interrumpid",
	"intersecad",
	"intersectad",
	"intervenid",
	"intestad",
	"intimad",
	"intimidad",
	"intitulad",
	"intoxicad",
	"intranquilizad",
	"intricad",
	"intrigad",
	"intrincad",
	"introducid",
	"intrusad",
	"intubad",
	"intuid",
	"inundad",
	"inutilizad",
	"invadid",
	"invaginad",
	"invalidad",
	"invenid",
	"inventad",
	"inventariad",
	"invernad",
	"invertid",
	"investid",
	"investigad",
	"inviabilizad",
	"invisibilizad",
	"invitad",
	"invocad",
	"involucionad",
	"involucrad",
	"inyectad",
	"iñocid",
	"ionizad",
	"irisad",
	"ironizad",
	"irradiad",
	"irrespetad",
	"irrigad",
	"irritad",
	"irrogad",
	"irrumpid",
	"islamizad",
	"italianizad",
	"iterad",
	"itinerad",
	"izad",
	"jabonad",
	"jactad",
	"jadead",
	"jalad",
	"jalbegad",
	"jalead",
	"jalonad",
	"jalonead",
	"jaquead",
	"jaquid",
	"jaranead",
	"jaspead",
	"jech",
	"jerarquizad",
	"jeringad",
	"jibarizad",
	"jimad",
	"jinetead",
	"jiñad",
	"jodid",
	"jonronead",
	"jorobad",
	"josead",
	"jotead",
	"jubilad",
	"judaizad",
	"judicializad",
	"jugad",
	"juguetead",
	"jumad",
	"juntad",
	"jurad",
	"juramentad",
	"justad",
	"justificad",
	"justipreciad",
	"juzgad",
	"labializad",
	"laborad",
	"labrad",
	"laburad",
	"lacad",
	"lacead",
	"lacerad",
	"lacrad",
	"lacrimad",
	"lactad",
	"ladead",
	"ladrad",
	"lagartead",
	"lagrimad",
	"lagrimead",
	"laicizad",
	"lalad",
	"lambid",
	"lambiscad",
	"lamentad",
	"lamid",
	"laminad",
	"lampad",
	"lampasead",
	"lancead",
	"languidecid",
	"lanzad",
	"lapidad",
	"lapizad",
	"laquead",
	"largad",
	"lascad",
	"lastimad",
	"lastrad",
	"lateralizad",
	"latid",
	"latinad",
	"latinizad",
	"laudad",
	"lauread",
	"lavad",
	"laxad",
	"lazad",
	"lechad",
	"legad",
	"legalizad",
	"legislad",
	"legitimad",
	"legitimizad",
	"leíd",
	"lematizad",
	"lengüetead",
	"lentificad",
	"leñad",
	"lesead",
	"lesionad",
	"leudad",
	"levad",
	"levantad",
	"levigad",
	"levitad",
	"lexicalizad",
	"liad",
	"libad",
	"liberad",
	"liberalizad",
	"libertad",
	"librad",
	"licenciad",
	"licitad",
	"licuad",
	"liderad",
	"lideread",
	"liderizad",
	"lidiad",
	"ligad",
	"lignificad",
	"lijad",
	"likead",
	"limad",
	"limitad",
	"limosnead",
	"limpiad",
	"linchad",
	"lindad",
	"linead",
	"linealizad",
	"liofilizad",
	"liquenizad",
	"liquidad",
	"lisiad",
	"lisonjead",
	"listad",
	"litad",
	"litigad",
	"litografiad",
	"lixiviad",
	"llagad",
	"llamad",
	"llamead",
	"llavead",
	"llegad",
	"llenad",
	"llevad",
	"llorad",
	"lloriquead",
	"llovid",
	"lloviznad",
	"load",
	"lobotomizad",
	"localizad",
	"locutad",
	"logad",
	"lograd",
	"loguead",
	"lonchead",
	"loncotead",
	"loquead",
	"lotead",
	"lotificad",
	"lubricad",
	"lubrificad",
	"luchad",
	"lucid",
	"lucrad",
	"ludid",
	"ludificad",
	"lustrad",
	"luxad",
	"macad",
	"macerad",
	"machacad",
	"machad",
	"machetead",
	"machihembrad",
	"machucad",
	"macizad",
	"macollad",
	"maculad",
	"madread",
	"madrugad",
	"madurad",
	"magancead",
	"magnetizad",
	"magnificad",
	"magread",
	"magulad",
	"magullad",
	"maicead",
	"majad",
	"malabaread",
	"malacostumbrad",
	"malbaratad",
	"malcriad",
	"maldecid",
	"maldit",
	"malead",
	"maleducad",
	"maleficiad",
	"malentendid",
	"malfuncionad",
	"malgastad",
	"malherid",
	"maliciad",
	"malinformad",
	"malinterpretad",
	"mallad",
	"malmatad",
	"malograd",
	"malparad",
	"malparid",
	"malpuest",
	"malquerid",
	"malquistad",
	"maltead",
	"maltraíd",
	"maltratad",
	"malvendid",
	"malversad",
	"malvivid",
	"mamad",
	"mamonead",
	"mampostead",
	"manad",
	"mancad",
	"manchad",
	"mancillad",
	"mancomunad",
	"mancornad",
	"mandad",
	"mandatad",
	"mandonead",
	"mandrilad",
	"manducad",
	"manead",
	"manejad",
	"mangad",
	"mangonead",
	"manguead",
	"maniatad",
	"manifestad",
	"maniobrad",
	"manipulad",
	"manosead",
	"manotead",
	"mantead",
	"mantenid",
	"manufacturad",
	"manumitid",
	"manuscript",
	"manuscrit",
	"manutenid",
	"mañanead",
	"mapead",
	"mapuchizad",
	"maquead",
	"maquetad",
	"maquilad",
	"maquillad",
	"maquinad",
	"maravillad",
	"marcad",
	"marchad",
	"marchitad",
	"maread",
	"marginad",
	"marginalizad",
	"maridad",
	"marinad",
	"mariposead",
	"mariscad",
	"marmolead",
	"marrad",
	"martillad",
	"martillead",
	"martirizad",
	"masacrad",
	"masad",
	"masajead",
	"mascad",
	"mascujad",
	"masculinizad",
	"mascullad",
	"masificad",
	"masterizad",
	"masticad",
	"masturbad",
	"matad",
	"matasellad",
	"matead",
	"materializad",
	"matizad",
	"matonead",
	"matraquead",
	"matriculad",
	"matrimoniad",
	"maullad",
	"maximizad",
	"mayad",
	"mazad",
	"maznad",
	"mead",
	"mecanizad",
	"mecanografiad",
	"mecatead",
	"mechad",
	"mecid",
	"mediad",
	"mediatizad",
	"medicad",
	"medicalizad",
	"medicinad",
	"medid",
	"meditad",
	"medrad",
	"mejorad",
	"melad",
	"melezinad",
	"melgad",
	"mellad",
	"membretad",
	"memorad",
	"memorializad",
	"memorizad",
	"menad",
	"mencionad",
	"mendigad",
	"menead",
	"menguad",
	"menoscabad",
	"menospreciad",
	"mensajead",
	"menstruad",
	"mensurad",
	"mentad",
	"mentalizad",
	"mentid",
	"mentorizad",
	"menudead",
	"menuzad",
	"mercad",
	"mercadead",
	"mercantilizad",
	"mercerizad",
	"merecid",
	"merendad",
	"merengad",
	"meritad",
	"mermad",
	"merodead",
	"mesad",
	"mestizad",
	"mesturad",
	"mesurad",
	"metabolizad",
	"metaforizad",
	"metalizad",
	"metamorfizad",
	"metamorfosead",
	"metastatizad",
	"metastizad",
	"meteorizad",
	"metid",
	"metilad",
	"metodizad",
	"metrificad",
	"mexicanizad",
	"mezclad",
	"mezquinad",
	"microfilmad",
	"microfinanciad",
	"microperforad",
	"microscopiad",
	"mielinizad",
	"migad",
	"migrad",
	"militad",
	"militarizad",
	"mimad",
	"mimeografiad",
	"mimetizad",
	"mimid",
	"minad",
	"mineralizad",
	"miniad",
	"miniaturizad",
	"minimalizad",
	"minimizad",
	"ministerializad",
	"ministrad",
	"minorad",
	"minusvalorad",
	"mirad",
	"misad",
	"misionad",
	"mistificad",
	"mitificad",
	"mitigad",
	"mixturad",
	"mocad",
	"mochad",
	"mochilead",
	"mocionad",
	"modelad",
	"modelizad",
	"moderad",
	"modernizad",
	"modificad",
	"modorrad",
	"modulad",
	"modularizad",
	"mofad",
	"mojad",
	"mojonad",
	"mojonead",
	"molad",
	"moldad",
	"moldead",
	"moldurad",
	"molestad",
	"molid",
	"molinad",
	"momificad",
	"mondad",
	"monetarizad",
	"monetizad",
	"monitoread",
	"monitorizad",
	"monologad",
	"monopolizad",
	"montad",
	"mopead",
	"moquead",
	"morad",
	"moralizad",
	"mordid",
	"mordiscad",
	"mordisquead",
	"morfad",
	"morigerad",
	"morread",
	"mortificad",
	"moscad",
	"mosquead",
	"mostrad",
	"mostread",
	"motead",
	"motejad",
	"motivad",
	"motorizad",
	"movid",
	"movilizad",
	"mudad",
	"muert",
	"muertead",
	"muestread",
	"mufad",
	"mugid",
	"mulcid",
	"muletead",
	"mulgid",
	"mullid",
	"multad",
	"multiplexad",
	"multiplicad",
	"mundializad",
	"municionad",
	"municipalizad",
	"munid",
	"muñid",
	"murad",
	"murmurad",
	"musealizad",
	"musicad",
	"musicalizad",
	"musid",
	"musitad",
	"mutad",
	"mutilad",
	"nacid",
	"nacionalizad",
	"nadad",
	"nalguead",
	"narcotizad",
	"narrad",
	"nasalizad",
	"naturalizad",
	"naufragad",
	"navalizad",
	"navegad",
	"nebulizad",
	"necead",
	"necesitad",
	"negad",
	"negligid",
	"negociad",
	"negread",
	"negrecid",
	"negrificad",
	"neocolonizad",
	"neutralizad",
	"nevad",
	"neviscad",
	"nidificad",
	"nimbad",
	"ningunead",
	"niquelad",
	"nitrificad",
	"nivelad",
	"nixtamalizad",
	"nombrad",
	"nominad",
	"nominalizad",
	"noquead",
	"normad",
	"normalizad",
	"normativizad",
	"notad",
	"notariad",
	"notarizad",
	"noticiad",
	"notificad",
	"novad",
	"novelad",
	"novelizad",
	"noviad",
	"nublad",
	"nuclead",
	"nudrid",
	"nukead",
	"nulificad",
	"numerad",
	"nutrid",
	"ñangotad",
	"ñoñead",
	"obcecad",
	"obedecid",
	"obispad",
	"objetad",
	"objetivad",
	"obligad",
	"obliterad",
	"obnubilad",
	"obrad",
	"obscurecid",
	"obsequiad",
	"observad",
	"obsesionad",
	"obstaculizad",
	"obstad",
	"obstinad",
	"obstruid",
	"obtenid",
	"obturad",
	"obviad",
	"ocasionad",
	"occidentalizad",
	"ocluid",
	"ocultad",
	"ocupad",
	"ocurrid",
	"odiad",
	"ofendid",
	"ofertad",
	"oficiad",
	"oficializad",
	"ofrecid",
	"ofrendad",
	"ofuscad",
	"oíd",
	"ojead",
	"okupad",
	"olead",
	"olfatead",
	"olid",
	"oliscad",
	"olisquead",
	"olvidad",
	"ominad",
	"omitid",
	"ondead",
	"ondulad",
	"opacad",
	"operad",
	"operativizad",
	"opinad",
	"opositad",
	"opresad",
	"oprimid",
	"optad",
	"optimad",
	"optimizad",
	"opuest",
	"opugnad",
	"orad",
	"oralizad",
	"orbitad",
	"ordenad",
	"ordeñad",
	"oread",
	"organizad",
	"orientad",
	"orientalizad",
	"originad",
	"orillad",
	"orinad",
	"orlad",
	"ornad",
	"ornamentad",
	"orquestad",
	"ortigad",
	"osad",
	"oscilad",
	"oscurecid",
	"osead",
	"osificad",
	"ostentad",
	"otad",
	"otead",
	"otorgad",
	"ovacionad",
	"ovad",
	"ovillad",
	"ovulad",
	"oxead",
	"oxidad",
	"oxigenad",
	"pacid",
	"pacificad",
	"pactad",
	"padecid",
	"pagad",
	"paginad",
	"pajaread",
	"pajaronead",
	"pajead",
	"palabread",
	"paladead",
	"palatalizad",
	"palead",
	"paletizad",
	"paliad",
	"palidecid",
	"paliquead",
	"pallad",
	"palmad",
	"palmead",
	"palmotead",
	"palpad",
	"palpitad",
	"pandead",
	"paniaguad",
	"papad",
	"parabolizad",
	"parad",
	"parafrasead",
	"paralelad",
	"paralelizad",
	"paralizad",
	"parametrad",
	"parametrizad",
	"parangonad",
	"parapetad",
	"parapetead",
	"parasitad",
	"parcelad",
	"parchad",
	"parchead",
	"parcializad",
	"paread",
	"parecid",
	"parid",
	"parlad",
	"parlamentad",
	"parlotead",
	"parodiad",
	"parpad",
	"parpadead",
	"parquead",
	"parquizad",
	"partead",
	"particionad",
	"participad",
	"particularizad",
	"partid",
	"partidizad",
	"pasad",
	"pasead",
	"pasmad",
	"pastad",
	"pastead",
	"pastelead",
	"pasterizad",
	"pasteurizad",
	"pastoread",
	"patalead",
	"patead",
	"patentad",
	"patentizad",
	"patinad",
	"patologizad",
	"patrimonializad",
	"patrocinad",
	"patronead",
	"patrullad",
	"patullad",
	"pauperizad",
	"pausad",
	"pautad",
	"pavimentad",
	"pavonad",
	"pavonead",
	"payasead",
	"peatonalizad",
	"pecad",
	"pechad",
	"pedalead",
	"pedid",
	"pedorread",
	"pegad",
	"pegotead",
	"peíd",
	"peinad",
	"pelad",
	"pelead",
	"pelechad",
	"peletizad",
	"peligrad",
	"pellizcad",
	"pelotead",
	"peluquead",
	"penad",
	"penalizad",
	"pendejead",
	"pendid",
	"pendonead",
	"penetrad",
	"penitenciad",
	"pensad",
	"pensionad",
	"pepead",
	"pepenad",
	"peraltad",
	"percatad",
	"perchad",
	"percibid",
	"percolad",
	"percudid",
	"percutad",
	"percutid",
	"perdid",
	"perdonad",
	"perdurad",
	"perecead",
	"perecid",
	"peregrinad",
	"perennizad",
	"perfeccionad",
	"perfilad",
	"perforad",
	"performad",
	"perfumad",
	"pergeñad",
	"periclitad",
	"perifonead",
	"perimetrad",
	"periodizad",
	"peritad",
	"perjudicad",
	"perjurad",
	"perlad",
	"permanecid",
	"permeabilizad",
	"permead",
	"permitid",
	"permutad",
	"pernead",
	"pernoctad",
	"peronizad",
	"perorad",
	"perpetrad",
	"perpetuad",
	"perquirid",
	"perread",
	"perseguid",
	"perseverad",
	"persignad",
	"persistid",
	"personad",
	"personalizad",
	"personificad",
	"persuadid",
	"pertenecid",
	"pertenid",
	"pertrechad",
	"perturbad",
	"pervertid",
	"pervivid",
	"pesad",
	"pescad",
	"pescuecead",
	"pespuntad",
	"pespuntead",
	"pesquisad",
	"pestañead",
	"petad",
	"petardead",
	"petead",
	"peticionad",
	"petrificad",
	"photoshopead",
	"piad",
	"piafad",
	"pialad",
	"picad",
	"pichad",
	"pichicatead",
	"pichulead",
	"picotead",
	"pifead",
	"pifiad",
	"pigmentad",
	"pignorad",
	"pilad",
	"pillad",
	"pilotad",
	"pilotead",
	"pimplad",
	"pincelad",
	"pinchad",
	"pingad",
	"pintad",
	"pintarrajead",
	"pintead",
	"pintorread",
	"pintorretead",
	"pinzad",
	"pipad",
	"pipiad",
	"piquetead",
	"pirad",
	"piratead",
	"pirograbad",
	"piropead",
	"pirrad",
	"pisad",
	"pisotead",
	"pispad",
	"pispead",
	"pistead",
	"pitad",
	"pitchead",
	"pitorread",
	"pivotad",
	"pivotead",
	"pixelad",
	"pizcad",
	"placad",
	"placead",
	"placid",
	"plagad",
	"plagiad",
	"planchad",
	"planchead",
	"planead",
	"planificad",
	"planillad",
	"plantad",
	"plantead",
	"plañid",
	"plasmad",
	"plastificad",
	"platead",
	"platicad",
	"plebiscitad",
	"plegad",
	"pleitead",
	"plisad",
	"plorad",
	"pluralizad",
	"pluriemplead",
	"plurinacionalizad",
	"poblad",
	"pochad",
	"pochead",
	"podad",
	"podemizad",
	"podid",
	"podrid",
	"poetizad",
	"polarizad",
	"polemizad",
	"policromad",
	"polid",
	"polimerizad",
	"polinizad",
	"politiquead",
	"politizad",
	"pololead",
	"ponchad",
	"ponderad",
	"pontificad",
	"ponzoñad",
	"popularizad",
	"pordiosead",
	"porfiad",
	"pormenorizad",
	"portad",
	"portead",
	"posad",
	"poseíd",
	"posesionad",
	"posibilitad",
	"posicionad",
	"positivad",
	"pospuest",
	"postead",
	"postensad",
	"postergad",
	"postpuest",
	"postrad",
	"postulad",
	"posturead",
	"potabilizad",
	"potad",
	"potenciad",
	"potencializad",
	"practicad",
	"pread",
	"preagrupad",
	"prealimentad",
	"preanunciad",
	"preaprobad",
	"prearmad",
	"preavisad",
	"prebendad",
	"precalentad",
	"precalificad",
	"precargad",
	"precarizad",
	"precautelad",
	"precavid",
	"precedid",
	"preceptuad",
	"preciad",
	"precintad",
	"precipitad",
	"precisad",
	"precocid",
	"precocinad",
	"precompilad",
	"precomprad",
	"preconcebid",
	"preconfigurad",
	"preconizad",
	"preconocid",
	"preconstituid",
	"preconvocad",
	"predad",
	"predestinad",
	"predeterminad",
	"predicad",
	"predich",
	"prediseñad",
	"predispuest",
	"predominad",
	"preelaborad",
	"preenvasad",
	"preestablecid",
	"preestrenad",
	"preferid",
	"prefigurad",
	"prefijad",
	"preformad",
	"pregad",
	"pregonad",
	"preguntad",
	"pregustad",
	"preinscript",
	"preinscrit",
	"preinstalad",
	"prejubilad",
	"prejuiciad",
	"prejuzgad",
	"preludiad",
	"premeditad",
	"premiad",
	"premostrad",
	"premuert",
	"prenasalizad",
	"prendad",
	"prendid",
	"prensad",
	"preñad",
	"preocupad",
	"preordenad",
	"prepagad",
	"preparad",
	"prepintad",
	"preponderad",
	"preprogramad",
	"presagiad",
	"prescindid",
	"prescript",
	"prescrit",
	"preseleccionad",
	"presenciad",
	"presentad",
	"presentid",
	"preservad",
	"presidid",
	"presionad",
	"presolicitad",
	"prestad",
	"prestigiad",
	"presumid",
	"presupuest",
	"presupuestad",
	"presurizad",
	"pretendid",
	"pretensad",
	"preterid",
	"pretermitid",
	"pretextad",
	"prevalecid",
	"prevalid",
	"prevaricad",
	"prevenid",
	"previsionad",
	"previst",
	"previsualizad",
	"primad",
	"principalizad",
	"principiad",
	"pringad",
	"priorizad",
	"privad",
	"privatizad",
	"privilegiad",
	"probad",
	"problematizad",
	"procedid",
	"procesad",
	"procesionad",
	"proclamad",
	"procrastinad",
	"procread",
	"procurad",
	"prodigad",
	"producid",
	"profanad",
	"proferid",
	"profesad",
	"profesionalizad",
	"profetizad",
	"profugad",
	"profundad",
	"profundizad",
	"programad",
	"progresad",
	"prohibid",
	"prohijad",
	"proletarizad",
	"proliferad",
	"prologad",
	"prolongad",
	"promediad",
	"promesad",
	"prometid",
	"promiscuad",
	"promocionad",
	"promovid",
	"promulgad",
	"pronominalizad",
	"pronosticad",
	"pronunciad",
	"propagad",
	"propalad",
	"propasad",
	"propendid",
	"propiciad",
	"propinad",
	"proporcionad",
	"propuest",
	"propugnad",
	"propulsad",
	"prorratead",
	"prorrogad",
	"prorrumpid",
	"proscript",
	"proscrit",
	"proseguid",
	"prospectad",
	"prosperad",
	"prosternad",
	"prostituid",
	"protagonizad",
	"protegid",
	"protestad",
	"protocolizad",
	"protonad",
	"prototipad",
	"protruid",
	"proveíd",
	"provenid",
	"provincializad",
	"provisionad",
	"provist",
	"provocad",
	"proyectad",
	"psicoanalizad",
	"publicad",
	"publicitad",
	"puentead",
	"puest",
	"pugnad",
	"pujad",
	"pulid",
	"pulimentad",
	"pulsad",
	"pulsead",
	"pululad",
	"pulverizad",
	"punchad",
	"puncionad",
	"pungid",
	"punid",
	"puntad",
	"puntead",
	"puntuad",
	"puntualizad",
	"punzad",
	"punzonad",
	"puñad",
	"puñetead",
	"purgad",
	"purificad",
	"purpurad",
	"putañead",
	"putead",
	"puyad",
	"quebrad",
	"quebrantad",
	"quedad",
	"quejad",
	"quelad",
	"quemad",
	"querellad",
	"querid",
	"quietad",
	"quilatad",
	"quimbad",
	"quintaesenciad",
	"quintuplicad",
	"quitad",
	"rabead",
	"rabiad",
	"racanead",
	"racializad",
	"raciocinad",
	"racionad",
	"racionalizad",
	"radiad",
	"radicad",
	"radicalizad",
	"radiodifundid",
	"radiografiad",
	"rafaguead",
	"raíd",
	"rajad",
	"rajuñad",
	"ralbad",
	"ralead",
	"ralentizad",
	"rallad",
	"ramblead",
	"ramificad",
	"ramonead",
	"rancad",
	"ranchad",
	"ranchead",
	"randomizad",
	"rankead",
	"ranquead",
	"ranurad",
	"rapad",
	"rapead",
	"rapiñad",
	"raptad",
	"raquead",
	"rarificad",
	"rasad",
	"rascad",
	"rascañad",
	"rascuñad",
	"rasgad",
	"rasguead",
	"rasguñad",
	"raspad",
	"rasquetead",
	"rasterizad",
	"rastrad",
	"rastread",
	"rastrillad",
	"rasurad",
	"ratead",
	"ratificad",
	"ratonad",
	"rayad",
	"razonad",
	"reabastecid",
	"reabiert",
	"reabsorbid",
	"reaccionad",
	"reacomodad",
	"reacondicionad",
	"reactivad",
	"reactualizad",
	"readaptad",
	"readecuad",
	"readiestrad",
	"readmitid",
	"readquirid",
	"reafirmad",
	"reagrupad",
	"reajustad",
	"realimentad",
	"realinead",
	"realistad",
	"realizad",
	"realojad",
	"realquilad",
	"realzad",
	"reanimad",
	"reanudad",
	"reaparecid",
	"reaplicad",
	"reaprendid",
	"reaprovechad",
	"reaprovisionad",
	"reargüid",
	"rearmad",
	"rearticulad",
	"reasegurad",
	"reasentad",
	"reasfaltad",
	"reasignad",
	"reasumid",
	"reatad",
	"reautorizad",
	"reavivad",
	"rebajad",
	"rebalancead",
	"rebalsad",
	"rebanad",
	"rebañad",
	"rebasad",
	"rebatad",
	"rebatid",
	"rebautizad",
	"rebelad",
	"reblandecid",
	"rebobinad",
	"rebordad",
	"rebordead",
	"rebosad",
	"rebotad",
	"rebozad",
	"rebramad",
	"rebrillad",
	"rebrincad",
	"rebrotad",
	"rebullid",
	"rebuscad",
	"rebuznad",
	"recabad",
	"recaíd",
	"recalad",
	"recalcad",
	"recalculad",
	"recalendarizad",
	"recalentad",
	"recalibrad",
	"recalificad",
	"recamad",
	"recapacitad",
	"recapitalizad",
	"recapitulad",
	"recapturad",
	"recargad",
	"recatad",
	"recatead",
	"recategorizad",
	"recauchutad",
	"recaudad",
	"recebid",
	"recelad",
	"recentad",
	"recentralizad",
	"recepcionad",
	"receptad",
	"recercad",
	"recertificad",
	"recesad",
	"recetad",
	"rechazad",
	"rechinad",
	"rechistad",
	"recibid",
	"reciclad",
	"reciprocad",
	"recirculad",
	"recitad",
	"reclamad",
	"reclasificad",
	"reclinad",
	"recluid",
	"reclutad",
	"recobrad",
	"recochinead",
	"recocid",
	"recocinad",
	"recodad",
	"recodificad",
	"recogid",
	"recolad",
	"recolectad",
	"recolegid",
	"recolocad",
	"recolonizad",
	"recombinad",
	"recomendad",
	"recomenzad",
	"recompensad",
	"recompilad",
	"recomprad",
	"recompuest",
	"reconcentrad",
	"reconceptualizad",
	"reconciliad",
	"reconcomid",
	"reconducid",
	"reconectad",
	"reconfigurad",
	"reconfirmad",
	"reconfortad",
	"reconocid",
	"reconquistad",
	"reconsagrad",
	"reconsiderad",
	"reconstituid",
	"reconstruid",
	"recontad",
	"recontextualizad",
	"recontratad",
	"reconvenid",
	"reconvertid",
	"recopilad",
	"recordad",
	"recorrid",
	"recortad",
	"recosid",
	"recostad",
	"recovad",
	"recread",
	"recrecid",
	"recriad",
	"recriminad",
	"recristalizad",
	"recrudecid",
	"rectificad",
	"rectorad",
	"recuadrad",
	"recubiert",
	"recudid",
	"reculad",
	"recuperad",
	"recurrid",
	"recurvad",
	"recusad",
	"redactad",
	"redargüid",
	"redecorad",
	"rededicad",
	"redefinid",
	"redemocratizad",
	"redenominad",
	"redensificad",
	"redescript",
	"redescrit",
	"redescubiert",
	"redesignad",
	"redibujad",
	"redich",
	"redimensionad",
	"redimid",
	"redireccionad",
	"redirigid",
	"rediscutid",
	"rediseñad",
	"redistribuid",
	"redituad",
	"redoblad",
	"redondead",
	"reducid",
	"redundad",
	"reedificad",
	"reeditad",
	"reeducad",
	"reelaborad",
	"reelect",
	"reelegid",
	"reembarcad",
	"reembolsad",
	"reemitid",
	"reemplazad",
	"reemprendid",
	"reenamorad",
	"reencaminad",
	"reencantad",
	"reencarnad",
	"reencauzad",
	"reencontrad",
	"reencuadernad",
	"reenergizad",
	"reenfocad",
	"reenganchad",
	"reensamblad",
	"reenterrad",
	"reentrad",
	"reentrenad",
	"reenvasad",
	"reenviad",
	"reequilibrad",
	"reequipad",
	"reescript",
	"reescrit",
	"reestabilizad",
	"reestablecid",
	"reestatizad",
	"reestilizad",
	"reestrenad",
	"reestructurad",
	"reevaluad",
	"reexaminad",
	"reexpedid",
	"refaccionad",
	"refacturad",
	"refanfinflad",
	"referenciad",
	"referid",
	"refigurad",
	"refilad",
	"refinad",
	"refinanciad",
	"reflectad",
	"reflejad",
	"reflexionad",
	"reflotad",
	"refluid",
	"refocilad",
	"reforestad",
	"reforjad",
	"reformad",
	"reformalizad",
	"reformatead",
	"reformulad",
	"reforzad",
	"refotografiad",
	"refractad",
	"refregad",
	"refreíd",
	"refrenad",
	"refrendad",
	"refrescad",
	"refrigerad",
	"refrit",
	"refugiad",
	"refulgid",
	"refundad",
	"refundid",
	"refunfuñad",
	"refutad",
	"regad",
	"regalad",
	"regalonead",
	"regañad",
	"regatead",
	"regazad",
	"regenerad",
	"regentad",
	"regentead",
	"regid",
	"regimentad",
	"regionalizad",
	"registrad",
	"reglad",
	"reglamentad",
	"regobernad",
	"regocijad",
	"regodead",
	"regoldad",
	"regrabad",
	"regresad",
	"reguetonead",
	"regulad",
	"regularizad",
	"regurgitad",
	"rehabilitad",
	"rehech",
	"rehidratad",
	"rehilad",
	"rehogad",
	"rehuid",
	"rehundid",
	"rehusad",
	"reíd",
	"reimaginad",
	"reimplantad",
	"reimpres",
	"reimprimid",
	"reimpuest",
	"reimpulsad",
	"reinad",
	"reinaugurad",
	"reincidid",
	"reincorporad",
	"reindustrializad",
	"reingresad",
	"reiniciad",
	"reinscript",
	"reinscrit",
	"reinsertad",
	"reinstalad",
	"reinstaurad",
	"reinstitucionalizad",
	"reintegrad",
	"reintensificad",
	"reintentad",
	"reinterpretad",
	"reintroducid",
	"reinventad",
	"reinvertid",
	"reiterad",
	"reivindicad",
	"rejuvenecid",
	"relacionad",
	"relajad",
	"relamid",
	"relampaguead",
	"relanzad",
	"relatad",
	"relativizad",
	"relegad",
	"relegitimad",
	"releíd",
	"relevad",
	"religad",
	"relinchad",
	"rellamad",
	"rellenad",
	"relocalizad",
	"relojead",
	"reluchad",
	"relucid",
	"relumbrad",
	"remachad",
	"remad",
	"remangad",
	"remansad",
	"remanufacturad",
	"remarcad",
	"remasterizad",
	"rematad",
	"rembolsad",
	"remecid",
	"remedad",
	"remediad",
	"rememorad",
	"remendad",
	"remezclad",
	"remirad",
	"remitid",
	"remixad",
	"remodelad",
	"remojad",
	"remolcad",
	"remoldead",
	"remolinead",
	"remolonead",
	"remontad",
	"remordid",
	"remotorizad",
	"removid",
	"remozad",
	"remplazad",
	"rempujad",
	"remudad",
	"remunerad",
	"remusgad",
	"renacid",
	"renacionalizad",
	"renderizad",
	"rendid",
	"renegad",
	"renegociad",
	"renguead",
	"renombrad",
	"renovad",
	"renquead",
	"rentabilizad",
	"rentad",
	"renumerad",
	"renunciad",
	"reñid",
	"reocupad",
	"reordenad",
	"reorganizad",
	"reorientad",
	"repagad",
	"repanchigad",
	"repantigad",
	"repantingad",
	"reparad",
	"repartid",
	"repasad",
	"repatead",
	"repatriad",
	"repautad",
	"repavimentad",
	"repechad",
	"repelad",
	"repelid",
	"repensad",
	"repentizad",
	"repercutid",
	"reperfilad",
	"repescad",
	"repetid",
	"repicad",
	"repintad",
	"repiquetead",
	"repisad",
	"replantad",
	"replantead",
	"replegad",
	"repletad",
	"replicad",
	"repoblad",
	"repolarizad",
	"repolitizad",
	"repollad",
	"reportad",
	"reportead",
	"reposad",
	"reposicionad",
	"repostad",
	"repostead",
	"repostulad",
	"repotenciad",
	"repreguntad",
	"reprehendid",
	"reprendid",
	"represad",
	"represaliad",
	"representad",
	"reprimid",
	"reprobad",
	"reprocesad",
	"reprochad",
	"reproducid",
	"reprogramad",
	"reptad",
	"republicad",
	"repudiad",
	"repuest",
	"repugnad",
	"repujad",
	"repulsad",
	"repuntad",
	"reputad",
	"requebrad",
	"requemad",
	"requerid",
	"requintad",
	"requisad",
	"resabid",
	"resacad",
	"resaltad",
	"resanad",
	"resarcid",
	"resbalad",
	"rescaldad",
	"rescatad",
	"rescindid",
	"rescript",
	"resecad",
	"resellad",
	"resemblad",
	"resembrad",
	"resentid",
	"reseñad",
	"reservad",
	"resetead",
	"resfriad",
	"resguardad",
	"residenciad",
	"residid",
	"resignad",
	"resignificad",
	"resincronizad",
	"resintonizad",
	"resistid",
	"resituad",
	"resobad",
	"resocializad",
	"resollad",
	"resonad",
	"resondrad",
	"resoplad",
	"resorbid",
	"respaldad",
	"respectad",
	"respetad",
	"respingad",
	"respirad",
	"resplandecid",
	"respondid",
	"responsabilizad",
	"resquebrad",
	"resquebrajad",
	"restablecid",
	"restad",
	"restallad",
	"restañad",
	"restaurad",
	"restead",
	"restituid",
	"restregad",
	"restringid",
	"restructurad",
	"resucitad",
	"resuelt",
	"resultad",
	"resumid",
	"resurgid",
	"retad",
	"retardad",
	"retemblad",
	"retemplad",
	"retenid",
	"reteñid",
	"retimbrad",
	"retipificad",
	"retirad",
	"retitulad",
	"retocad",
	"retomad",
	"retoñad",
	"retorcid",
	"retornad",
	"retortijad",
	"retozad",
	"retractad",
	"retraducid",
	"retraíd",
	"retranquead",
	"retransmitid",
	"retrasad",
	"retrasmitid",
	"retratad",
	"retrepad",
	"retribuid",
	"retroalimentad",
	"retrocad",
	"retrocedid",
	"retrogradad",
	"retroiluminad",
	"retrotraíd",
	"retrovendid",
	"retrucad",
	"retuitead",
	"retumbad",
	"retundid",
	"retwitead",
	"retwittead",
	"reubicad",
	"reunid",
	"reunificad",
	"reurbanizad",
	"reusad",
	"reutilizad",
	"revacunad",
	"revalidad",
	"revalorad",
	"revalorizad",
	"revaluad",
	"revelad",
	"revencid",
	"revendid",
	"revenid",
	"reventad",
	"reverberad",
	"reverdecid",
	"reverenciad",
	"reversad",
	"reversionad",
	"revertid",
	"revesad",
	"revestid",
	"revictimizad",
	"revinculad",
	"revirad",
	"revisad",
	"revisionad",
	"revisitad",
	"revist",
	"revistad",
	"revitalizad",
	"revivid",
	"revivificad",
	"revocad",
	"revolad",
	"revolcad",
	"revolead",
	"revolotead",
	"revolucionad",
	"revuelt",
	"rezad",
	"rezagad",
	"rezongad",
	"rezumad",
	"rezurcid",
	"ribetead",
	"ridiculizad",
	"rielad",
	"rifad",
	"rilad",
	"rimad",
	"rimbombad",
	"ringad",
	"ripead",
	"ripiad",
	"ripostad",
	"ritualizad",
	"rivalizad",
	"rizad",
	"robad",
	"robotizad",
	"robustecid",
	"rochad",
	"rociad",
	"rockanrolead",
	"rockead",
	"rodad",
	"rodead",
	"rogad",
	"roíd",
	"rojead",
	"rolad",
	"romancead",
	"romanizad",
	"romantizad",
	"romanzad",
	"rompid",
	"roncad",
	"rondad",
	"ronead",
	"ronronead",
	"ronzad",
	"rootead",
	"roquead",
	"roscad",
	"rosead",
	"rostizad",
	"rot",
	"rotad",
	"rotomoldead",
	"rotulad",
	"roturad",
	"rozad",
	"ruborizad",
	"rubricad",
	"rugad",
	"rugid",
	"ruinad",
	"rulad",
	"rumbead",
	"rumbiad",
	"rumiad",
	"rumorad",
	"rumoread",
	"runrunead",
	"ruralizad",
	"rusificad",
	"rusticad",
	"rutead",
	"rutilad",
	"sabid",
	"sablead",
	"saboread",
	"saborizad",
	"sabotead",
	"sacad",
	"sacarificad",
	"sachad",
	"saciad",
	"sacodid",
	"sacralizad",
	"sacramentad",
	"sacrificad",
	"sacudid",
	"saetad",
	"saetead",
	"sahumad",
	"sajad",
	"salad",
	"salariad",
	"saldad",
	"salid",
	"salinizad",
	"salivad",
	"sallad",
	"salmodiad",
	"salpicad",
	"salpimentad",
	"salpresad",
	"salsead",
	"saltad",
	"saltead",
	"saludad",
	"salvad",
	"salvaguardad",
	"sambenitad",
	"samplead",
	"sanad",
	"sancionad",
	"sancochad",
	"sandunguead",
	"sanead",
	"sangrad",
	"sanitizad",
	"sanjad",
	"santificad",
	"santiguad",
	"sapead",
	"saponificad",
	"saquead",
	"sargentead",
	"sarmentad",
	"satanizad",
	"satinad",
	"satirizad",
	"satisfech",
	"saturad",
	"sazonad",
	"secad",
	"seccionad",
	"secretad",
	"secretead",
	"sectorizad",
	"secuenciad",
	"secuestrad",
	"secularizad",
	"secundad",
	"sedad",
	"sedentarizad",
	"sedimentad",
	"seducid",
	"segad",
	"segmentad",
	"segregad",
	"seguid",
	"segundad",
	"segurad",
	"seleccionad",
	"selfiad",
	"sellad",
	"semaforizad",
	"semblad",
	"sembrad",
	"semejad",
	"sementad",
	"sensibilizad",
	"sentad",
	"sentenciad",
	"sentid",
	"señad",
	"señalad",
	"señalizad",
	"señoread",
	"separad",
	"sepultad",
	"sequestrad",
	"serenad",
	"seriad",
	"serializad",
	"serigrafiad",
	"sermonead",
	"serpead",
	"serpentead",
	"serrad",
	"serruchad",
	"servid",
	"sesead",
	"sesgad",
	"sesionad",
	"sestead",
	"setead",
	"sexad",
	"sextuplicad",
	"sexualizad",
	"shockead",
	"sicoanalizad",
	"sid",
	"sigilad",
	"signad",
	"significad",
	"silabad",
	"silabead",
	"silbad",
	"silenciad",
	"siluetead",
	"simbolizad",
	"simpatizad",
	"simplificad",
	"simulad",
	"simultanead",
	"sincerad",
	"sincopad",
	"sincretizad",
	"sincronizad",
	"sindicad",
	"sindicalizad",
	"singad",
	"singularizad",
	"sinonimizad",
	"sinterizad",
	"sintetizad",
	"sintonizad",
	"sirgad",
	"sisad",
	"sisead",
	"sistematizad",
	"sitiad",
	"situad",
	"sobad",
	"sobajad",
	"sobornad",
	"sobrad",
	"sobreactuad",
	"sobrealimentad",
	"sobreasad",
	"sobrecalentad",
	"sobrecargad",
	"sobrecogid",
	"sobreconsumid",
	"sobrecumplid",
	"sobredemandad",
	"sobredeterminad",
	"sobredimensionad",
	"sobredorad",
	"sobredosificad",
	"sobreentendid",
	"sobreescript",
	"sobreescrit",
	"sobreestimad",
	"sobreestimulad",
	"sobreexcitad",
	"sobreexplotad",
	"sobreexpresad",
	"sobreexpuest",
	"sobregirad",
	"sobregrabad",
	"sobreimpres",
	"sobreimprimid",
	"sobreinfectad",
	"sobrellenad",
	"sobrellevad",
	"sobremedicad",
	"sobrenadad",
	"sobrentendid",
	"sobrepasad",
	"sobrepoblad",
	"sobreprotegid",
	"sobrepuest",
	"sobrepujad",
	"sobrerreaccionad",
	"sobrerrepresentad",
	"sobresalid",
	"sobresaltad",
	"sobresaturad",
	"sobrescript",
	"sobrescrit",
	"sobreseíd",
	"sobrestimad",
	"sobrevalorad",
	"sobrevaluad",
	"sobrevenid",
	"sobrevirad",
	"sobrevivid",
	"sobrevolad",
	"socarrad",
	"socavad",
	"sociabilizad",
	"socializad",
	"socorrid",
	"sodomizad",
	"sofisticad",
	"sofocad",
	"sofreíd",
	"sofrenad",
	"sofrit",
	"soguead",
	"sojuzgad",
	"solad",
	"solapad",
	"solarizad",
	"solazad",
	"soldad",
	"solead",
	"solemnizad",
	"solevad",
	"solfead",
	"solicitad",
	"solid",
	"solidad",
	"solidarizad",
	"solidificad",
	"soliviantad",
	"sollozad",
	"soltad",
	"solubilizad",
	"solucionad",
	"solventad",
	"somatizad",
	"sombrad",
	"sombread",
	"sometid",
	"somorgujad",
	"sompesad",
	"sonad",
	"sondad",
	"sondead",
	"sonorizad",
	"sonreíd",
	"sonrojad",
	"sonrosad",
	"sonsacad",
	"soñad",
	"sopad",
	"sopesad",
	"soplad",
	"soportad",
	"sorbid",
	"sorprendid",
	"sortead",
	"sosegad",
	"soslayad",
	"sospechad",
	"sostenid",
	"sotad",
	"soterrad",
	"stalkead",
	"suavizad",
	"subalimentad",
	"subalquilad",
	"subalternizad",
	"subarrendad",
	"subastad",
	"subclasificad",
	"subcontratad",
	"subdividid",
	"subducid",
	"subentendid",
	"subestimad",
	"subid",
	"sublevad",
	"sublimad",
	"subministrad",
	"subordinad",
	"subrayad",
	"subrogad",
	"subsanad",
	"subscript",
	"subscrit",
	"subseguid",
	"subsidiad",
	"subsistid",
	"substanciad",
	"substantivad",
	"substituid",
	"substraíd",
	"subsumid",
	"subtendid",
	"subtitulad",
	"subutilizad",
	"subvaluad",
	"subvencionad",
	"subvenid",
	"subvertid",
	"subvirad",
	"subyacid",
	"subyugad",
	"succionad",
	"sucedid",
	"sucitad",
	"sucumbid",
	"sudad",
	"suelt",
	"sufijad",
	"sufragad",
	"sufrid",
	"sugerid",
	"sugestionad",
	"suicidad",
	"sujetad",
	"sujuzgad",
	"sulcad",
	"sulfatad",
	"sulfurad",
	"sumad",
	"sumariad",
	"sumergid",
	"sumid",
	"suministrad",
	"supeditad",
	"superad",
	"superimpuest",
	"superpoblad",
	"superpuest",
	"supervalorad",
	"supervenid",
	"supervigilad",
	"supervisad",
	"supervivid",
	"suplantad",
	"suplementad",
	"suplicad",
	"suplid",
	"suprimid",
	"supuest",
	"supurad",
	"suputad",
	"surcad",
	"surcid",
	"surfead",
	"surgid",
	"surtid",
	"suscitad",
	"suscript",
	"suscrit",
	"suspendid",
	"suspirad",
	"sustanciad",
	"sustantivad",
	"sustentad",
	"sustituid",
	"sustraíd",
	"susurrad",
	"sutilizad",
	"suturad",
	"tabicad",
	"tablad",
	"tabletead",
	"tabulad",
	"tachad",
	"tachonad",
	"tacid",
	"tacklead",
	"taclead",
	"taconead",
	"tajad",
	"talad",
	"taladrad",
	"tallad",
	"tambalead",
	"tamboread",
	"tamborilead",
	"tamizad",
	"tamponad",
	"tangad",
	"tanquead",
	"tantead",
	"tañid",
	"tapad",
	"tapead",
	"tapiad",
	"tapiscad",
	"tapizad",
	"taponad",
	"taponead",
	"taquead",
	"taquillad",
	"taracead",
	"tarad",
	"tararead",
	"tardad",
	"tarifad",
	"tarificad",
	"tarjad",
	"tartamudead",
	"tasad",
	"tascad",
	"tatemad",
	"tatuad",
	"taxiad",
	"teatralizad",
	"techad",
	"teclead",
	"tecnificad",
	"tejad",
	"tejid",
	"telefonead",
	"telegrafiad",
	"teleportad",
	"teletrabajad",
	"teletransportad",
	"televisad",
	"telonead",
	"temad",
	"tematizad",
	"temblad",
	"temblequead",
	"temid",
	"temperad",
	"templad",
	"temporizad",
	"tendid",
	"tenid",
	"tensad",
	"tensionad",
	"tentad",
	"teñid",
	"teorizad",
	"tercerizad",
	"terciad",
	"terciarizad",
	"tergiversad",
	"terminad",
	"ternad",
	"terracead",
	"terraformad",
	"terraplenad",
	"territorializad",
	"tertuliad",
	"tesad",
	"testad",
	"testead",
	"testificad",
	"testiguad",
	"testimoniad",
	"textead",
	"texturizad",
	"tictaquead",
	"tijeretead",
	"tildad",
	"timad",
	"timbead",
	"timbrad",
	"timonead",
	"tincad",
	"tintad",
	"tintinead",
	"tinturad",
	"tipad",
	"tipead",
	"tipificad",
	"tipologizad",
	"tirad",
	"tiranizad",
	"tiritad",
	"tironead",
	"tirotead",
	"titilad",
	"titrad",
	"titubad",
	"titubead",
	"titulad",
	"titularizad",
	"tiznad",
	"tocad",
	"togad",
	"toldad",
	"tolerad",
	"tollid",
	"tomad",
	"tongonead",
	"tonificad",
	"tonsurad",
	"tontead",
	"topad",
	"topead",
	"topetad",
	"toquetead",
	"torcid",
	"toread",
	"tormientad",
	"tornad",
	"tornead",
	"torpedead",
	"torrad",
	"torturad",
	"tosid",
	"tostad",
	"totalizad",
	"toxificad",
	"trabad",
	"trabajad",
	"trabucad",
	"traccionad",
	"traducid",
	"traficad",
	"tragad",
	"traicionad",
	"traíd",
	"trajead",
	"trajinad",
	"tramad",
	"tramitad",
	"trampead",
	"trancad",
	"tranquead",
	"tranquilizad",
	"transad",
	"transbordad",
	"transcendid",
	"transcodificad",
	"transcript",
	"transcrit",
	"transcurrid",
	"transfectad",
	"transferid",
	"transfigurad",
	"transformad",
	"transfundid",
	"transgredid",
	"transicionad",
	"transigid",
	"transistorizad",
	"transitad",
	"transladad",
	"transliterad",
	"translocad",
	"translucid",
	"transmigrad",
	"transmitid",
	"transmutad",
	"transparentad",
	"transpirad",
	"transplantad",
	"transportad",
	"transpuest",
	"transtornad",
	"transustanciad",
	"transvasad",
	"transversalizad",
	"tranzad",
	"trapacead",
	"trapalead",
	"trapead",
	"trapichead",
	"traquetead",
	"trasbordad",
	"trascendid",
	"trascript",
	"trascrit",
	"trascurrid",
	"trasegad",
	"trasferid",
	"trasfigurad",
	"trasformad",
	"trasgredid",
	"trashumad",
	"trasladad",
	"traslapad",
	"trasliterad",
	"trasluchad",
	"traslucid",
	"trasmigrad",
	"trasmitid",
	"trasmontad",
	"trasmutad",
	"trasnochad",
	"trasoíd",
	"traspalad",
	"traspapelad",
	"trasparentad",
	"traspasad",
	"traspillad",
	"traspirad",
	"trasplantad",
	"trasportad",
	"traspuest",
	"trasquilad",
	"trastabillad",
	"trastabillead",
	"trastead",
	"trastocad",
	"trastornad",
	"trastrabillad",
	"trastrocad",
	"trasudad",
	"trasuntad",
	"trasvasad",
	"tratad",
	"traumad",
	"traumatizad",
	"travestid",
	"trazad",
	"trebejad",
	"trechad",
	"trefilad",
	"tremid",
	"tremolad",
	"trenad",
	"trenzad",
	"trepad",
	"trepanad",
	"trepidad",
	"triangulad",
	"tribulad",
	"tributad",
	"tricotad",
	"trillad",
	"trinad",
	"trincad",
	"trinchad",
	"triplicad",
	"triptongad",
	"tripulad",
	"triscad",
	"trisecad",
	"tristead",
	"triturad",
	"triunfad",
	"trivializad",
	"trocad",
	"trocead",
	"trolead",
	"trompetead",
	"trompezad",
	"trompicad",
	"tronad",
	"troncad",
	"tronchad",
	"tropezad",
	"tropicalizad",
	"troquelad",
	"trotad",
	"trovad",
	"trozad",
	"trucad",
	"trucidad",
	"trufad",
	"truncad",
	"truquead",
	"tugurizad",
	"tuitead",
	"tullid",
	"tumbad",
	"tumultuad",
	"tunad",
	"tundid",
	"tunead",
	"tunelad",
	"tupid",
	"turbad",
	"turbinad",
	"turboalimentad",
	"turbocargad",
	"turistead",
	"turistificad",
	"turnad",
	"turquead",
	"tusad",
	"tutead",
	"tutelad",
	"twitead",
	"twittead",
	"ubicad",
	"ufanad",
	"ulcerad",
	"ultimad",
	"ultracentrifugad",
	"ultrajad",
	"ululad",
	"uncid",
	"ungid",
	"unid",
	"unificad",
	"uniformad",
	"uniformizad",
	"universalizad",
	"untad",
	"upad",
	"urbanizad",
	"urdid",
	"urgid",
	"uruguayizad",
	"usad",
	"ustedead",
	"usucapid",
	"usufructuad",
	"usurpad",
	"utilizad",
	"vacacionad",
	"vacad",
	"vaciad",
	"vacilad",
	"vacunad",
	"vadead",
	"vagabundead",
	"vagad",
	"vaguead",
	"valid",
	"validad",
	"vallad",
	"valorad",
	"valorizad",
	"valsad",
	"valuad",
	"vampirizad",
	"vanagloriad",
	"vandalizad",
	"vapead",
	"vaporizad",
	"vapulead",
	"varad",
	"varead",
	"variad",
	"vascularizad",
	"vaticinad",
	"vectorizad",
	"vedad",
	"vegetad",
	"vehiculad",
	"vehiculizad",
	"vejad",
	"velad",
	"velarizad",
	"velicad",
	"venadead",
	"vencid",
	"vendad",
	"vendid",
	"vendimiad",
	"venenciad",
	"venerad",
	"vengad",
	"venid",
	"ventad",
	"ventead",
	"ventilad",
	"ventosead",
	"veranead",
	"verbalizad",
	"verberad",
	"verdead",
	"verdeguead",
	"verguead",
	"verificad",
	"versad",
	"versead",
	"versificad",
	"versionad",
	"versionead",
	"vertebrad",
	"verticalizad",
	"vertid",
	"vestid",
	"vetad",
	"vetead",
	"vezad",
	"viabilizad",
	"viajad",
	"viboread",
	"vibrad",
	"vichead",
	"viciad",
	"victimad",
	"victimizad",
	"victoread",
	"videograbad",
	"vidriad",
	"vigilad",
	"vigorizad",
	"vilipendiad",
	"vinculad",
	"vindicad",
	"vinificad",
	"violad",
	"violentad",
	"virad",
	"viralizad",
	"virtualizad",
	"visad",
	"visibilizad",
	"visionad",
	"visitad",
	"vislumbrad",
	"visoriad",
	"vist",
	"visualizad",
	"vitalizad",
	"vitoread",
	"vitrificad",
	"vituperad",
	"vivad",
	"vivaquead",
	"vivenciad",
	"vivid",
	"vivificad",
	"vocalizad",
	"vocead",
	"vociferad",
	"volad",
	"volantead",
	"volatilizad",
	"volcad",
	"volead",
	"voltead",
	"voltejead",
	"vomitad",
	"vosead",
	"votad",
	"voznad",
	"vuelt",
	"vulcanizad",
	"vulgarizad",
	"vulnerad",
	"wasapead",
	"whatsappead",
	"wikificad",
	"xerocopiad",
	"xerografiad",
	"yacid",
	"yantad",
	"yapad",
	"yerad",
	"yermad",
	"yirad",
	"yodurad",
	"yugulad",
	"yuxtapuest",
	"zabordad",
	"zabullid",
	"zafad",
	"zaherid",
	"zamarread",
	"zambullid",
	"zampad",
	"zancadillead",
	"zancajead",
	"zanganead",
	"zanjad",
	"zanquead",
	"zapad",
	"zapatead",
	"zapead",
	"zarandead",
	"zarpad",
	"zascandilead",
	"zigzaguead",
	"zombificad",
	"zonificad",
	"zorread",
	"zozobrad",
	"zumbad",
	"zurcid",
	"zuread",
	"zurrad",
	"zurriad",
	"zurrid",
	"zuzad",
];

